<template>
  <div
    class="property-detail layout-pb-lg"
    v-if="variants.v1 === variant"
    :style="`background-color: var(--c-${vars.backgroundColor});`"
  >
    <section class="relative !tw-block !tw-pt-44 tw-pb-6 lg:tw-pb-12">
      <div class="container">
        <library-properties-back-to-all-properties-navbar text="BACK TO ALL PROPERTIES" color="#1B3B47" />
      </div>
      <div data-anim="slide-up delay-1" class="tabs__content pt-60 md:pt-30 js-tabs-content">
        <div class="tabs__pane -tab-item-1 is-tab-el-active">
          <div class="row justify-center">
            <div class="col-xl-5 col-lg-6 col-md-9">
              <div class="relative js-section-slider" data-slider-cols="xl-1 lg-1 md-1 sm-1 base-1" data-loop>
                <div class="swiper-wrapper h-auto items-center-imp -image-slider-1">
                  <div v-for="(image, index) in allPhotos" class="swiper-slide relative">
                    <div class="ratio ratio-16:9 !tw-z-0">
                      <library-image
                        :src="image.background"
                        alt="image"
                        image-class="img-ratio !tw-z-0 tw-cursor-grab"
                        @click="(onClickedImage(image), toggleHeader())"
                        :blur="imageBlurFilter"
                        :pre-market-blur-text="preMarketBlurText"
                      />
                      <div v-if="property && property.medias" class="nc-first-image-overlay-item">
                        <div
                          style="
                            border-radius: var(--rounded-sm);
                            color: var(--c-primary);
                            background-color: var(--c-section_primary);
                          "
                          @click="(onClickedImage(image), toggleHeader())"
                          class="tw-text-md tw-px-2 tw-py-1"
                        >
                          {{ index + 1 }}/{{ property.medias.length }}
                        </div>
                      </div>
                    </div>
                    <div class="exploreButton !tw-z-50 tw-cursor-grab">
                      <button
                        style="color: var(--c-primary)"
                        class="button bg-dark-1 fw-500 rounded-full tw-h-14 tw-w-14 !tw-rounded-full !tw-bg-white !tw-p-6 md:tw-h-16 md:tw-w-16 lg:tw-h-20 lg:tw-w-20"
                      >
                        SWIPE
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section
      v-if="property"
      class="tw-pb-6 lg:tw-pb-12"
      :style="{
        backgroundColor: vars.backgroundColor ? `var(--c-${vars.backgroundColor})` : 'var(--c-section_secondary)',
      }"
    >
      <!-- GALLERY: END -->

      <div class="container">
        <div class="property-detail-info tw-flex tw-w-full tw-flex-col tw-py-12">
          <div class="tw-grid tw-grid-cols-12 tw-items-start tw-justify-between">
            <div class="tw-col-span-12 tw-flex tw-flex-col lg:tw-col-span-7">
              <h3>{{ property.advert_heading }}</h3>
              <div class="address tw-mt-5 tw-flex tw-items-center tw-gap-1">
                <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M11.5 12.5C10.8078 12.5 10.1311 12.2947 9.55551 11.9101C8.97993 11.5256 8.53133 10.9789 8.26642 10.3394C8.00152 9.69985 7.9322 8.99612 8.06725 8.31719C8.2023 7.63825 8.53564 7.01461 9.02513 6.52513C9.51461 6.03564 10.1383 5.7023 10.8172 5.56725C11.4961 5.4322 12.1999 5.50152 12.8394 5.76642C13.4789 6.03133 14.0256 6.47993 14.4101 7.05551C14.7947 7.63108 15 8.30777 15 9C14.9989 9.92792 14.6298 10.8175 13.9736 11.4736C13.3175 12.1298 12.4279 12.4989 11.5 12.5ZM11.5 6.9C11.0847 6.9 10.6786 7.02316 10.3333 7.25392C9.98796 7.48467 9.7188 7.81264 9.55985 8.19637C9.40091 8.58009 9.35932 9.00233 9.44035 9.40969C9.52138 9.81705 9.72139 10.1912 10.0151 10.4849C10.3088 10.7786 10.683 10.9786 11.0903 11.0596C11.4977 11.1407 11.9199 11.0991 12.3036 10.9401C12.6874 10.7812 13.0153 10.512 13.2461 10.1667C13.4768 9.82136 13.6 9.41534 13.6 9C13.5994 8.44322 13.378 7.9094 12.9843 7.51569C12.5906 7.12199 12.0568 6.90056 11.5 6.9Z"
                    :fill="property.is_rent ? 'var(--c-tertiary)' : 'var(--c-secondary)'"
                  />
                  <path
                    d="M11.5 21.5L5.74819 14.3936C5.66826 14.2869 5.58917 14.1795 5.51091 14.0714C4.5289 12.7153 3.99818 11.0594 4 9.35714C4 7.2733 4.79018 5.2748 6.1967 3.8013C7.60322 2.3278 9.51088 1.5 11.5 1.5C13.4891 1.5 15.3968 2.3278 16.8033 3.8013C18.2098 5.2748 19 7.2733 19 9.35714C19.0016 11.0585 18.4711 12.7136 17.4898 14.0693L17.4891 14.0714C17.4891 14.0714 17.2845 14.3529 17.2539 14.3907L11.5 21.5ZM6.59978 13.2107C6.59978 13.2107 6.75864 13.4307 6.79478 13.4779L11.5 19.2914L16.2114 13.47C16.2414 13.4307 16.4009 13.2093 16.4016 13.2086C17.2042 12.1008 17.638 10.7479 17.6364 9.35714C17.6364 7.65218 16.9899 6.01705 15.8391 4.81146C14.6883 3.60587 13.1275 2.92857 11.5 2.92857C9.87254 2.92857 8.31173 3.60587 7.16094 4.81146C6.01015 6.01705 5.36364 7.65218 5.36364 9.35714C5.36196 10.7488 5.79622 12.1026 6.59978 13.2107Z"
                    :fill="property.is_rent ? 'var(--c-tertiary)' : 'var(--c-secondary)'"
                  />
                </svg>

                <p class="tw-capitalize">{{ property.display_address }}</p>
              </div>
              <div v-if="!property?.is_locked" class="tw-mt-5 tw-flex tw-items-center tw-gap-1">
                <div class="rooms tw-flex tw-flex-row tw-items-center tw-gap-4">
                  <div class="tw-flex tw-items-center tw-gap-2">
                    <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M3 18.5V11.5H4V7.5H20V11.5H21V18.5H20V16.5H4V18.5H3ZM12.5 11.5H19V8.5H12.5V11.5ZM5 11.5H11.5V8.5H5V11.5ZM4 15.5H20V12.5H4V15.5Z"
                        :fill="property.is_rent ? 'var(--c-tertiary)' : 'var(--c-secondary)'"
                      />
                    </svg>
                    <p>{{ property.bedroom }} Beds</p>
                  </div>

                  <div class="tw-flex tw-items-center tw-gap-2">
                    <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M3 12.1552H22M8.7 19.0517H16.3M8.7 19.0517C7.69218 19.0517 6.72563 18.6158 6.01299 17.8398C5.30036 17.0637 4.9 16.0112 4.9 14.9138V6.63793C4.9 5.54048 5.30036 4.48798 6.01299 3.71197C6.72563 2.93596 7.69218 2.5 8.7 2.5H11.2333V4.56897M8.7 19.0517V22.5M16.3 19.0517C17.3078 19.0517 18.2744 18.6158 18.987 17.8398C19.6996 17.0637 20.1 16.0112 20.1 14.9138V12.1552M16.3 19.0517V22.5M9.33333 6.63793H13.1333"
                        :stroke="property.is_rent ? 'var(--c-tertiary)' : 'var(--c-secondary)'"
                      />
                    </svg>

                    <p>{{ property.bathroom }} Baths</p>
                  </div>

                  <div class="tw-flex tw-items-center tw-gap-2">
                    <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M3 16.4001V19.1001M4.8 10.1001V8.30006C4.8 7.82267 4.98964 7.36483 5.32721 7.02727C5.66477 6.6897 6.12261 6.50006 6.6 6.50006H17.4C17.8774 6.50006 18.3352 6.6897 18.6728 7.02727C19.0104 7.36483 19.2 7.82267 19.2 8.30006V10.1001"
                        :stroke="property.is_rent ? 'var(--c-tertiary)' : 'var(--c-secondary)'"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M21 16.4001V19.1001M19.2 10.1001C18.7226 10.1001 18.2648 10.2897 17.9272 10.6273C17.5896 10.9649 17.4 11.4227 17.4 11.9001V13.7001H6.6V11.9001C6.6 11.4227 6.41036 10.9649 6.07279 10.6273C5.73523 10.2897 5.27739 10.1001 4.8 10.1001C4.32261 10.1001 3.86477 10.2897 3.52721 10.6273C3.18964 10.9649 3 11.4227 3 11.9001V17.3001H21V11.9001C21 11.4227 20.8104 10.9649 20.4728 10.6273C20.1352 10.2897 19.6774 10.1001 19.2 10.1001Z"
                        :stroke="property.is_rent ? 'var(--c-tertiary)' : 'var(--c-secondary)'"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>

                    <p>{{ property.reception }} Reception</p>
                  </div>
                </div>
              </div>
            </div>
            <div
              class="tw-col-span-12 tw-flex tw-flex-col tw-justify-between lg:tw-col-span-5 lg:tw-items-end lg:tw-justify-end lg:tw-gap-8"
            >
              <div
                class="tw-mt-5 tw-flex tw-w-full tw-items-center tw-justify-between max-lg:tw-pt-4 lg:tw-justify-end lg:tw-gap-8"
              >
                <div v-if="property.price" class="tw-flex tw-flex-col lg:tw-items-end">
                  <h4 v-if="property.price.type.name" class="tw-mb-4 tw-uppercase">
                    {{ property.price.type.name }}
                  </h4>
                  <h2 :style="{ color: property.is_rent ? 'var(--c-tertiary)' : 'var(--c-secondary)' }">
                    {{ property.price.price }}
                  </h2>
                </div>
              </div>
              <button
                v-if="!property?.is_locked"
                :class="property.is_rent ? 'n-tertiary' : 'n-secondary'"
                class="tw-mt-12 tw-w-full tw-self-start md:tw-w-auto lg:tw-mt-6 lg:tw-self-end"
                @click="(onSendLead(), toggleHeader())"
              >
                BOOK A VIEWING
              </button>
            </div>
          </div>
        </div>
        <div v-if="featuredVideo && matterPort" class="tw-mt-8 tw-flex tw-flex-col tw-gap-6 lg:tw-flex-row">
          <div class="tw-aspect-video tw-w-full lg:tw-w-1/2">
            <library-iframe
              class="tw-inset-0"
              :src="featuredVideo"
              frameborder="0"
              allowfullscreen
              :blur="imageBlurFilter"
              :pre-market-blur-text="preMarketBlurText"
            ></library-iframe>
          </div>
          <div class="tw-aspect-video tw-w-full lg:tw-w-1/2">
            <library-iframe
              class="tw-inset-0"
              :src="matterPort"
              frameborder="0"
              allowfullscreen
              :blur="imageBlurFilter"
              :pre-market-blur-text="preMarketBlurText"
            ></library-iframe>
          </div>
        </div>
      </div>
    </section>

    <!-- PROPERTY DETAIL -->
    <template v-if="!property.is_locked">
      <section class="!tw-pt-0" style="background-color: var(--c-section_primary)">
        <div class="container">
          <div class="tw-grid tw-grid-cols-12 md:tw-gap-x-10">
            <div class="tw-col-span-12 tw-flex tw-flex-col tw-gap-y-12 lg:tw-col-span-7 xl:tw-col-span-8">
              <div v-if="featuredVideo && !matterPort" class="tw-mt-8 tw-flex tw-flex-col tw-gap-6 lg:tw-flex-row">
                <div class="tw-aspect-video tw-w-full">
                  <library-iframe
                    class="tw-inset-0"
                    :src="featuredVideo"
                    frameborder="0"
                    allowfullscreen
                    :blur="imageBlurFilter"
                    :pre-market-blur-text="preMarketBlurText"
                  ></library-iframe>
                </div>
              </div>
              <div v-if="!featuredVideo && matterPort" class="tw-mt-8 tw-flex tw-flex-col tw-gap-6 lg:tw-flex-row">
                <div class="tw-aspect-video tw-w-full">
                  <library-iframe
                    class="tw-inset-0"
                    :src="matterPort"
                    frameborder="0"
                    allowfullscreen
                    :blur="imageBlurFilter"
                    :pre-market-blur-text="preMarketBlurText"
                  ></library-iframe>
                </div>
              </div>
              <ul
                class="nav nav-tabs pxp-nav-tabs tw-my-8 tw-flex tw-flex-row tw-flex-wrap tw-items-center tw-justify-center tw-gap-10 lg:tw-justify-start"
              >
                <li v-for="(tab, tabIndex) in tabs" :key="`tab-${tabIndex}`" class="nav-item">
                  <div
                    :class="
                      activeTab.name === tab.name
                        ? property.is_rent
                          ? '!tw-text-[var(--c-tertiary)]'
                          : '!tw-text-[var(--c-secondary)]'
                        : ''
                    "
                    class="nav-link tw-cursor-pointer tw-font-bold"
                    data-toggle="tab"
                    @click="
                      () => {
                        activeTab.name = tab.name;
                        activeTab.title = tab.title;
                      }
                    "
                  >
                    {{ tab.title }}
                  </div>
                </li>
              </ul>
              <div class="tab-content tw-my-6">
                <div v-if="activeTab.name === 'features'">
                  <h4 class="tw-pb-4">{{ activeTab.title }}</h4>
                  <div v-if="property?.features" class="tw-mt-8 tw-grid tw-grid-cols-12 tw-gap-4">
                    <div
                      v-for="(feature, index) in property.features"
                      :key="`property-feature-${index}`"
                      class="tw-col-span-12 tw-flex tw-items-start tw-gap-x-3 md:tw-col-span-6 xl:tw-col-span-4"
                    >
                      <span>
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path
                            d="M9.5501 18L3.8501 12.3L5.2751 10.875L9.5501 15.15L18.7251 5.97498L20.1501 7.39998L9.5501 18Z"
                            :fill="property.is_rent ? 'var(--c-tertiary)' : 'var(--c-secondary)'"
                          />
                        </svg>
                      </span>
                      <library-text class="tw-text-sm tw-font-semibold tw-uppercase" :text="feature"> </library-text>
                    </div>
                  </div>
                </div>

                <div v-if="activeTab.name === 'property_information'" id="property_information" role="tabpanel">
                  <h4 class="tw-pb-4">{{ activeTab.title }}</h4>

                  <library-text
                    class="tw-text-sm"
                    style="font-family: var(--f-primary) !important"
                    :html="property.description"
                  ></library-text>

                  <!-- amenties -->
                  <div
                    class="tw-mt-4 tw-flex tw-flex-col tw-gap-4 md:tw-mt-8 md:tw-flex-row md:tw-flex-wrap md:tw-gap-6"
                  >
                    <div
                      v-for="criteria in property.criteria_list"
                      :key="criteria.id"
                      class="tw-flex tw-gap-4 tw-p-4"
                      style="background-color: var(--c-section_primary); border-radius: var(--rounded)"
                    >
                      <span v-if="criteria.title === 'Parking'">
                        <svg width="48" height="49" viewBox="0 0 48 49" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path
                            d="M45 21.5955H42.7312L37.4231 9.65358C37.2168 9.18982 36.8805 8.79581 36.4549 8.51927C36.0293 8.24273 35.5326 8.09552 35.025 8.09546H12.975C12.4674 8.09552 11.9707 8.24273 11.5451 8.51927C11.1195 8.79581 10.7832 9.18982 10.5769 9.65358L5.26875 21.5955H3C2.70163 21.5955 2.41548 21.714 2.2045 21.925C1.99353 22.1359 1.875 22.4221 1.875 22.7205C1.875 23.0188 1.99353 23.305 2.2045 23.516C2.41548 23.7269 2.70163 23.8455 3 23.8455H4.875V39.2205C4.875 39.9167 5.15156 40.5843 5.64384 41.0766C6.13613 41.5689 6.80381 41.8455 7.5 41.8455H12C12.6962 41.8455 13.3639 41.5689 13.8562 41.0766C14.3484 40.5843 14.625 39.9167 14.625 39.2205V35.8455H33.375V39.2205C33.375 39.9167 33.6516 40.5843 34.1438 41.0766C34.6361 41.5689 35.3038 41.8455 36 41.8455H40.5C41.1962 41.8455 41.8639 41.5689 42.3562 41.0766C42.8484 40.5843 43.125 39.9167 43.125 39.2205V23.8455H45C45.2984 23.8455 45.5845 23.7269 45.7955 23.516C46.0065 23.305 46.125 23.0188 46.125 22.7205C46.125 22.4221 46.0065 22.1359 45.7955 21.925C45.5845 21.714 45.2984 21.5955 45 21.5955ZM12.6319 10.5686C12.6613 10.5021 12.7094 10.4457 12.7703 10.4061C12.8312 10.3665 12.9023 10.3454 12.975 10.3455H35.025C35.0977 10.3454 35.1688 10.3665 35.2297 10.4061C35.2906 10.4457 35.3387 10.5021 35.3681 10.5686L40.2694 21.5955H7.73063L12.6319 10.5686ZM12.375 39.2205C12.375 39.3199 12.3355 39.4153 12.2652 39.4856C12.1948 39.556 12.0995 39.5955 12 39.5955H7.5C7.40054 39.5955 7.30516 39.556 7.23483 39.4856C7.16451 39.4153 7.125 39.3199 7.125 39.2205V35.8455H12.375V39.2205ZM40.5 39.5955H36C35.9005 39.5955 35.8052 39.556 35.7348 39.4856C35.6645 39.4153 35.625 39.3199 35.625 39.2205V35.8455H40.875V39.2205C40.875 39.3199 40.8355 39.4153 40.7652 39.4856C40.6948 39.556 40.5995 39.5955 40.5 39.5955ZM40.875 33.5955H7.125V23.8455H40.875V33.5955ZM10.875 28.7205C10.875 28.4221 10.9935 28.1359 11.2045 27.925C11.4155 27.714 11.7016 27.5955 12 27.5955H15C15.2984 27.5955 15.5845 27.714 15.7955 27.925C16.0065 28.1359 16.125 28.4221 16.125 28.7205C16.125 29.0188 16.0065 29.305 15.7955 29.516C15.5845 29.7269 15.2984 29.8455 15 29.8455H12C11.7016 29.8455 11.4155 29.7269 11.2045 29.516C10.9935 29.305 10.875 29.0188 10.875 28.7205ZM31.875 28.7205C31.875 28.4221 31.9935 28.1359 32.2045 27.925C32.4155 27.714 32.7016 27.5955 33 27.5955H36C36.2984 27.5955 36.5845 27.714 36.7955 27.925C37.0065 28.1359 37.125 28.4221 37.125 28.7205C37.125 29.0188 37.0065 29.305 36.7955 29.516C36.5845 29.7269 36.2984 29.8455 36 29.8455H33C32.7016 29.8455 32.4155 29.7269 32.2045 29.516C31.9935 29.305 31.875 29.0188 31.875 28.7205Z"
                            :fill="property.is_rent ? 'var(--c-tertiary)' : 'var(--c-secondary)'"
                          />
                        </svg>
                      </span>

                      <span v-else-if="criteria.title === 'Sewerage'">
                        <svg width="48" height="49" viewBox="0 0 48 49" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path
                            d="M43.5 20.0955H38.625V10.3455H43.5C43.7984 10.3455 44.0845 10.2269 44.2955 10.016C44.5065 9.80498 44.625 9.51883 44.625 9.22046C44.625 8.92209 44.5065 8.63594 44.2955 8.42496C44.0845 8.21399 43.7984 8.09546 43.5 8.09546H38.3681C38.1555 7.6472 37.8202 7.26837 37.4011 7.00289C36.9819 6.7374 36.4961 6.59614 36 6.59546H33C32.5039 6.59614 32.0181 6.7374 31.5989 7.00289C31.1798 7.26837 30.8445 7.6472 30.6319 8.09546H27C21.9296 8.10141 17.0685 10.1183 13.4832 13.7036C9.89782 17.289 7.88095 22.15 7.875 27.2205V30.8523C7.42674 31.065 7.04791 31.4003 6.78243 31.8194C6.51694 32.2385 6.37568 32.7243 6.375 33.2205V36.2205C6.37568 36.7166 6.51694 37.2024 6.78243 37.6215C7.04791 38.0406 7.42674 38.376 7.875 38.5886V43.7205C7.875 44.0188 7.99353 44.305 8.2045 44.516C8.41548 44.7269 8.70163 44.8455 9 44.8455C9.29837 44.8455 9.58452 44.7269 9.7955 44.516C10.0065 44.305 10.125 44.0188 10.125 43.7205V38.8455H19.875V43.7205C19.875 44.0188 19.9935 44.305 20.2045 44.516C20.4155 44.7269 20.7016 44.8455 21 44.8455C21.2984 44.8455 21.5845 44.7269 21.7955 44.516C22.0065 44.305 22.125 44.0188 22.125 43.7205V38.5886C22.5733 38.376 22.9521 38.0406 23.2176 37.6215C23.4831 37.2024 23.6243 36.7166 23.625 36.2205V33.2205C23.6243 32.7243 23.4831 32.2385 23.2176 31.8194C22.9521 31.4003 22.5733 31.065 22.125 30.8523V27.2205C22.125 25.9275 22.6386 24.6876 23.5529 23.7733C24.4671 22.8591 25.7071 22.3455 27 22.3455H30.6319C30.8445 22.7937 31.1798 23.1726 31.5989 23.438C32.0181 23.7035 32.5039 23.8448 33 23.8455H36C36.4961 23.8448 36.9819 23.7035 37.4011 23.438C37.8202 23.1726 38.1555 22.7937 38.3681 22.3455H43.5C43.7984 22.3455 44.0845 22.2269 44.2955 22.016C44.5065 21.805 44.625 21.5188 44.625 21.2205C44.625 20.9221 44.5065 20.6359 44.2955 20.425C44.0845 20.214 43.7984 20.0955 43.5 20.0955ZM21 32.8455C21.0995 32.8455 21.1948 32.885 21.2652 32.9553C21.3355 33.0256 21.375 33.121 21.375 33.2205V36.2205C21.375 36.3199 21.3355 36.4153 21.2652 36.4856C21.1948 36.556 21.0995 36.5955 21 36.5955H9C8.90054 36.5955 8.80516 36.556 8.73483 36.4856C8.66451 36.4153 8.625 36.3199 8.625 36.2205V33.2205C8.625 33.121 8.66451 33.0256 8.73483 32.9553C8.80516 32.885 8.90054 32.8455 9 32.8455H21ZM19.875 27.2205V30.5955H10.125V27.2205C10.13 22.7465 11.9095 18.4571 15.0731 15.2935C18.2367 12.1299 22.526 10.3504 27 10.3455H30.375V20.0955H27C25.1103 20.0955 23.2981 20.8461 21.9619 22.1823C20.6257 23.5185 19.875 25.3308 19.875 27.2205ZM36 21.5955H33C32.9005 21.5955 32.8052 21.556 32.7348 21.4856C32.6645 21.4153 32.625 21.3199 32.625 21.2205V9.22046C32.625 9.121 32.6645 9.02562 32.7348 8.95529C32.8052 8.88497 32.9005 8.84546 33 8.84546H36C36.0995 8.84546 36.1948 8.88497 36.2652 8.95529C36.3355 9.02562 36.375 9.121 36.375 9.22046V21.2205C36.375 21.3199 36.3355 21.4153 36.2652 21.4856C36.1948 21.556 36.0995 21.5955 36 21.5955Z"
                            :fill="property.is_rent ? 'var(--c-tertiary)' : 'var(--c-secondary)'"
                          />
                        </svg>
                      </span>

                      <span v-else-if="criteria.title === 'Water'">
                        <svg width="48" height="49" viewBox="0 0 48 49" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path
                            d="M5 34.6805V32.6045C6.036 32.4765 6.84267 32.1365 7.42 31.5845C7.99867 31.0338 9.092 30.7585 10.7 30.7585C12.3853 30.7585 13.5747 31.0918 14.268 31.7585C14.9613 32.4251 15.9847 32.7585 17.338 32.7585C18.7073 32.7585 19.7387 32.4251 20.432 31.7585C21.1253 31.0918 22.3147 30.7585 24 30.7585C25.6693 30.7585 26.8587 31.0918 27.568 31.7585C28.2773 32.4251 29.3087 32.7585 30.662 32.7585C32.0313 32.7585 33.0587 32.4251 33.744 31.7585C34.4307 31.0918 35.616 30.7585 37.3 30.7585C38.908 30.7585 40.0013 31.0345 40.58 31.5865C41.1573 32.1371 41.964 32.4771 43 32.6065V34.6825C41.792 34.5278 40.8333 34.1685 40.124 33.6045C39.4147 33.0405 38.4733 32.7585 37.3 32.7585C35.972 32.7585 34.9547 33.0918 34.248 33.7585C33.5413 34.4251 32.346 34.7585 30.662 34.7585C28.9927 34.7585 27.8033 34.4251 27.094 33.7585C26.3847 33.0918 25.3533 32.7591 24 32.7605C22.6307 32.7605 21.5993 33.0938 20.906 33.7605C20.2127 34.4271 19.0233 34.7605 17.338 34.7605C15.6527 34.7605 14.4613 34.4271 13.764 33.7605C13.0667 33.0938 12.0453 32.7605 10.7 32.7605C9.484 32.7605 8.54867 33.0425 7.894 33.6065C7.23933 34.1718 6.27467 34.5311 5 34.6845M5 27.1445V25.0685C6.036 24.9405 6.84267 24.6005 7.42 24.0485C7.99867 23.4978 9.092 23.2225 10.7 23.2225C12.3693 23.2225 13.5547 23.5558 14.256 24.2225C14.9573 24.8891 15.9847 25.2225 17.338 25.2225C18.7073 25.2225 19.7387 24.8891 20.432 24.2225C21.1253 23.5558 22.3147 23.2218 24 23.2205C25.6693 23.2205 26.856 23.5538 27.56 24.2205C28.264 24.8871 29.2907 25.2205 30.64 25.2205C32.008 25.2205 33.0387 24.8871 33.732 24.2205C34.4253 23.5538 35.6147 23.2205 37.3 23.2205C38.892 23.2205 39.9853 23.4965 40.58 24.0485C41.1733 24.5991 41.98 24.9385 43 25.0665V27.1425C41.7773 26.9891 40.8153 26.6305 40.114 26.0665C39.4127 25.5025 38.4747 25.2205 37.3 25.2205C35.972 25.2205 34.9547 25.5538 34.248 26.2205C33.5413 26.8871 32.346 27.2205 30.662 27.2205C28.9927 27.2205 27.8033 26.8871 27.094 26.2205C26.386 25.5538 25.3547 25.2205 24 25.2205C22.6307 25.2205 21.6033 25.5538 20.918 26.2205C20.2313 26.8871 19.046 27.2205 17.362 27.2205C15.678 27.2205 14.478 26.8871 13.762 26.2205C13.046 25.5538 12.0253 25.2205 10.7 25.2205C9.5 25.2205 8.56467 25.5025 7.894 26.0665C7.22333 26.6305 6.25867 26.9898 5 27.1445ZM5 19.6045V17.5285C6.036 17.4005 6.84267 17.0605 7.42 16.5085C7.99867 15.9578 9.092 15.6825 10.7 15.6825C12.3693 15.6825 13.5547 16.0158 14.256 16.6825C14.9573 17.3491 15.9847 17.6825 17.338 17.6825C18.7073 17.6825 19.7387 17.3491 20.432 16.6825C21.1253 16.0158 22.3147 15.6818 24 15.6805C25.6693 15.6805 26.856 16.0138 27.56 16.6805C28.264 17.3471 29.2907 17.6805 30.64 17.6805C32.008 17.6805 33.0387 17.3471 33.732 16.6805C34.4253 16.0138 35.6147 15.6805 37.3 15.6805C38.892 15.6805 39.9853 15.9558 40.58 16.5065C41.1733 17.0585 41.98 17.3985 43 17.5265V19.6025C41.7773 19.4491 40.8153 19.0905 40.114 18.5265C39.4127 17.9625 38.4747 17.6805 37.3 17.6805C35.972 17.6805 34.9547 18.0138 34.248 18.6805C33.5413 19.3471 32.346 19.6805 30.662 19.6805C28.9927 19.6805 27.8033 19.3471 27.094 18.6805C26.386 18.0138 25.3547 17.6805 24 17.6805C22.6307 17.6805 21.6033 18.0138 20.918 18.6805C20.2313 19.3471 19.046 19.6805 17.362 19.6805C15.678 19.6805 14.478 19.3471 13.762 18.6805C13.046 18.0138 12.0253 17.6805 10.7 17.6805C9.5 17.6805 8.552 17.9625 7.856 18.5265C7.16 19.0905 6.208 19.4498 5 19.6045Z"
                            :fill="property.is_rent ? 'var(--c-tertiary)' : 'var(--c-secondary)'"
                          />
                        </svg>
                      </span>
                      <span v-else>
                        <svg width="48" height="49" viewBox="0 0 48 49" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <g clip-path="url(#clip0_481_37820)">
                            <path
                              d="M44.9467 23.2738L24.9467 3.27383C24.6969 3.0255 24.359 2.88611 24.0067 2.88611C23.6545 2.88611 23.3165 3.0255 23.0667 3.27383L3.0667 23.2738C2.84827 23.5289 2.73413 23.857 2.74709 24.1926C2.76005 24.5281 2.89916 24.8465 3.13662 25.0839C3.37408 25.3214 3.6924 25.4605 4.02797 25.4734C4.36353 25.4864 4.69163 25.3723 4.9467 25.1538L24 6.1005L43.0534 25.1672C43.3084 25.3856 43.6365 25.4997 43.9721 25.4868C44.3077 25.4738 44.626 25.3347 44.8635 25.0972C45.1009 24.8598 45.24 24.5415 45.253 24.2059C45.2659 23.8703 45.1518 23.5422 44.9334 23.2872L44.9467 23.2738Z"
                              :fill="property.is_rent ? 'var(--c-tertiary)' : 'var(--c-secondary)'"
                            />
                            <path
                              d="M37.3333 42.8872H30.6667V29.5538H17.3333V42.8872H10.6667V24.2205L8 26.8872V42.8872C8 43.5944 8.28095 44.2727 8.78105 44.7728C9.28115 45.2729 9.95942 45.5538 10.6667 45.5538H20V32.2205H28V45.5538H37.3333C38.0406 45.5538 38.7189 45.2729 39.219 44.7728C39.7191 44.2727 40 43.5944 40 42.8872V26.5672L37.3333 23.9005V42.8872Z"
                              :fill="property.is_rent ? 'var(--c-tertiary)' : 'var(--c-secondary)'"
                            />
                          </g>
                          <defs>
                            <clipPath id="clip0_481_37820">
                              <rect width="48" height="48" fill="white" transform="translate(0 0.220459)" />
                            </clipPath>
                          </defs>
                        </svg>
                      </span>
                      <div>
                        <small class="n-title-primary tw-uppercase">{{ criteria.title }}</small>
                        <p>{{ criteria.value }}</p>
                      </div>
                    </div>
                  </div>
                </div>

                <div v-if="activeTab.name === 'floor_plan'" id="floor_plan" role="tabpanel">
                  <h4 class="tw-pb-4">{{ activeTab.title }}</h4>

                  <floor-plan :data="property.floor_plans" :component="component" />
                </div>

                <div v-if="activeTab.name === 'map'" id="map" role="tabpanel">
                  <h4 class="tw-pb-4">{{ activeTab.title }}</h4>

                  <neuron-google-map
                    v-if="property.map_position && property.map_position.lat && property.map_position.lng"
                    v-model:map-center-position="property.map_position"
                    :component="component"
                    :marker-color="markerColor"
                  />
                </div>
                <div v-if="activeTab.name === 'epc'" id="epc" role="tabpanel">
                  <h4 class="tw-pb-4">{{ activeTab.title }}</h4>
                  <epc :data="property.epcs" :component="component" />
                </div>
              </div>
              <div
                v-if="isMortgageCalculatorVisible && property?.is_rent === false"
                class="mortgage tw-mt-12 lg:tw-mt-24"
                :class="property.is_rent ? 'rent-property' : 'sales-property'"
              >
                <library-tools-mortgage-calculator :default-price="property.price.numberPrice" />
              </div>

              <div
                v-if="isStampDutyCalculatorVisible && property?.is_rent === false"
                class="stamp tw-mt-12 lg:tw-mt-24"
                :class="property.is_rent ? 'rent-property' : 'sales-property'"
              >
                <library-tools-stamp-duty-calculator :default-price="property.price.numberPrice" />
              </div>
            </div>
            <div class="tw-col-span-12 tw-pt-6 lg:tw-col-span-5 xl:tw-col-span-4">
              <div v-if="sidebarComponents && sidebarComponents.length" class="tw-flex tw-flex-col tw-gap-4">
                <div v-if="vars.viewingOptionsBool">
                  <div
                    class="tw-relative tw-flex tw-w-full tw-flex-col tw-justify-center tw-gap-5 tw-px-4 tw-py-9 tw-text-start"
                    :style="`background-color: var(--c-sidebar-card); border-radius: var(--rounded);`"
                  >
                    <h4>{{ vars.viewingOptionsTitleText }}</h4>
                    <p v-if="vars.viewingOptionsDescriptionText">
                      {{ vars.viewingOptionsDescriptionText }}
                    </p>
                    <div class="tw-mt-2 tw-flex tw-flex-col tw-gap-4">
                      <button
                        v-if="featuredVideo"
                        :class="`n-${vars.viewingOptionsButton1TypeText} tw-w-fit`"
                        @click="onVidePopup()"
                      >
                        {{ vars.viewingOptionsButton1LabelText }}
                      </button>
                      <button :class="`n-${vars.viewingOptionsButton2TypeText} tw-w-fit`" @click="onSendLead()">
                        {{ vars.viewingOptionsButton2LabelText }}
                      </button>
                    </div>
                  </div>
                </div>
                <theme7-available-components-for-sidebar
                  key="property-detail-sidebar"
                  key-prefix="property-detail-sidebar"
                  :specific-components="sidebarComponents"
                />
              </div>
            </div>
          </div>
        </div>

        <full-screen-gallery
          v-if="fullScreenPopupConfig.is_active && activeMedia && property && property.medias"
          v-model:active-media-index="activeMediaIndex"
          :component="component"
          :active-media="activeMedia"
          :count-of-medias="property.medias.length"
          @close="(closeLightbox(), toggleHeader())"
        />

        <popup :config="sendLeadPopupConfig" custom-width="800px">
          <template #content>
            <send-lead
              v-if="sendLeadPopupConfig.isActive"
              :property="property"
              @on-success="onSuccess"
              @close="sendLeadPopupConfig.isActive = false"
            />
          </template>
        </popup>

        <popup :config="videoPopupConfig" v-if="videoPopupConfig.videoPopupSrc" custom-width="500px" @close="stopVideo">
          <template #content>
            <div class="tw-relative tw-pt-6">
              <div class="tw-aspect-[9/16] tw-h-full tw-w-full">
                <library-iframe
                  class="tw-absolute tw-inset-0 tw-h-full tw-w-full"
                  :src="videoPopupConfig.videoPopupSrc"
                  frameborder="0"
                  allowfullscreen
                  :blur="imageBlurFilter"
                  :pre-market-blur-text="preMarketBlurText"
                ></library-iframe>
              </div>
            </div>
          </template>
        </popup>

        <popup :config="successModalConfig" @close="onSuccessModalClosed()">
          <template #content>
            <success :text="successPopupText" />
          </template>
        </popup>
      </section>
    </template>
    <template v-else-if="property.is_locked">
      <section class="!tw-pt-0" style="background-color: var(--c-section_primary)">
        <div class="container">
          <library-login />
        </div>
      </section>
    </template>
  </div>

  <div
    class="property-detail layout-pb-lg"
    v-if="variants.v2 === variant"
    :style="`background-color: var(--c-${vars.backgroundColor});`"
  >
    <section class="layout-pb-lg relative !tw-block !tw-pt-44">
      <div class="container">
        <library-properties-back-to-all-properties-navbar
          class="tw-mb-10"
          text="BACK TO ALL PROPERTIES"
          color="var(--c-primary)"
        />
      </div>
      <div data-anim="slide-up delay-1" class="tabs__content js-tabs-content">
        <div class="tabs__pane -tab-item-1 is-tab-el-active">
          <div class="container">
            <div class="row justify-center">
              <div class="col-12">
                <div
                  class="relative js-section-slider"
                  data-anim="slide-left delay-1"
                  data-gap="20"
                  data-slider-cols="xl-2.25 lg-2.25 md-1.25 sm-1 base-1"
                >
                  <div class="swiper-wrapper">
                    <div
                      v-for="(image, index) in maxPhotosToShow"
                      :key="`property-detail-image-${index}`"
                      class="swiper-slide relative"
                    >
                      <div class="ratio ratio-16:9 !tw-z-0">
                        <library-image
                          :src="image.background"
                          alt="image"
                          image-class="img-ratio !tw-z-0 tw-cursor-grab"
                          @click="(onClickedImage(image), toggleHeader())"
                          :blur="imageBlurFilter"
                          :pre-market-blur-text="preMarketBlurText"
                        />
                        <div v-if="property && property.medias && index === 0" class="nc-first-image-overlay-item">
                          <div
                            style="
                              border-radius: var(--rounded-sm);
                              color: var(--c-primary);
                              background-color: var(--c-section_primary);
                            "
                            @click="(onClickedImage(image), toggleHeader())"
                            class="tw-text-md tw-px-2 tw-py-1"
                          >
                            {{ index + 1 }}/{{ property.medias.length }}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="d-flex mt-60 md:mt-30 max-lg:tw-items-center max-lg:tw-justify-center">
                    <button class="sliderNav -prev js-prev n-link" @click="slidePrev">
                      <i class="icon-left-arrow"></i>
                    </button>
                    <button class="sliderNav -next ml-20 js-next n-link" @click="slideNext">
                      <i class="icon-right-arrow"></i>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section v-if="property" class="layout-pb-md" style="background-color: var(--c-section_primary)">
      <!-- GALLERY: END -->

      <div class="container">
        <div class="property-detail-info tw-flex tw-w-full tw-flex-col tw-py-12">
          <div class="tw-grid tw-grid-cols-12 tw-items-start tw-justify-between">
            <div class="tw-col-span-12 tw-flex tw-flex-col lg:tw-col-span-7">
              <h3 style="color: var(--c-text_primary)">{{ property.advert_heading }}</h3>
              <div class="address tw-mt-5 tw-flex tw-items-center tw-gap-1">
                <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M11.5 12.5C10.8078 12.5 10.1311 12.2947 9.55551 11.9101C8.97993 11.5256 8.53133 10.9789 8.26642 10.3394C8.00152 9.69985 7.9322 8.99612 8.06725 8.31719C8.2023 7.63825 8.53564 7.01461 9.02513 6.52513C9.51461 6.03564 10.1383 5.7023 10.8172 5.56725C11.4961 5.4322 12.1999 5.50152 12.8394 5.76642C13.4789 6.03133 14.0256 6.47993 14.4101 7.05551C14.7947 7.63108 15 8.30777 15 9C14.9989 9.92792 14.6298 10.8175 13.9736 11.4736C13.3175 12.1298 12.4279 12.4989 11.5 12.5ZM11.5 6.9C11.0847 6.9 10.6786 7.02316 10.3333 7.25392C9.98796 7.48467 9.7188 7.81264 9.55985 8.19637C9.40091 8.58009 9.35932 9.00233 9.44035 9.40969C9.52138 9.81705 9.72139 10.1912 10.0151 10.4849C10.3088 10.7786 10.683 10.9786 11.0903 11.0596C11.4977 11.1407 11.9199 11.0991 12.3036 10.9401C12.6874 10.7812 13.0153 10.512 13.2461 10.1667C13.4768 9.82136 13.6 9.41534 13.6 9C13.5994 8.44322 13.378 7.9094 12.9843 7.51569C12.5906 7.12199 12.0568 6.90056 11.5 6.9Z"
                    fill="var(--c-primary)"
                  />
                  <path
                    d="M11.5 21.5L5.74819 14.3936C5.66826 14.2869 5.58917 14.1795 5.51091 14.0714C4.5289 12.7153 3.99818 11.0594 4 9.35714C4 7.2733 4.79018 5.2748 6.1967 3.8013C7.60322 2.3278 9.51088 1.5 11.5 1.5C13.4891 1.5 15.3968 2.3278 16.8033 3.8013C18.2098 5.2748 19 7.2733 19 9.35714C19.0016 11.0585 18.4711 12.7136 17.4898 14.0693L17.4891 14.0714C17.4891 14.0714 17.2845 14.3529 17.2539 14.3907L11.5 21.5ZM6.59978 13.2107C6.59978 13.2107 6.75864 13.4307 6.79478 13.4779L11.5 19.2914L16.2114 13.47C16.2414 13.4307 16.4009 13.2093 16.4016 13.2086C17.2042 12.1008 17.638 10.7479 17.6364 9.35714C17.6364 7.65218 16.9899 6.01705 15.8391 4.81146C14.6883 3.60587 13.1275 2.92857 11.5 2.92857C9.87254 2.92857 8.31173 3.60587 7.16094 4.81146C6.01015 6.01705 5.36364 7.65218 5.36364 9.35714C5.36196 10.7488 5.79622 12.1026 6.59978 13.2107Z"
                    fill="var(--c-primary)"
                  />
                </svg>

                <p class="tw-capitalize" style="color: var(--c-text_primary)">{{ property.display_address }}</p>
              </div>
              <div v-if="!property.is_locked" class="tw-mt-5 tw-flex tw-items-center tw-gap-1">
                <div class="rooms tw-flex tw-flex-row tw-items-center tw-gap-4">
                  <div class="tw-flex tw-items-center tw-gap-2">
                    <svg
                      width="24"
                      height="25"
                      viewBox="0 0 24 25"
                      fill="var(--c-primary)"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M3 18.5V11.5H4V7.5H20V11.5H21V18.5H20V16.5H4V18.5H3ZM12.5 11.5H19V8.5H12.5V11.5ZM5 11.5H11.5V8.5H5V11.5ZM4 15.5H20V12.5H4V15.5Z"
                        fill="var(--c-primary)"
                      />
                    </svg>
                    <p>{{ property.bedroom }} Beds</p>
                  </div>

                  <div class="tw-flex tw-items-center tw-gap-2">
                    <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M3 12.1552H22M8.7 19.0517H16.3M8.7 19.0517C7.69218 19.0517 6.72563 18.6158 6.01299 17.8398C5.30036 17.0637 4.9 16.0112 4.9 14.9138V6.63793C4.9 5.54048 5.30036 4.48798 6.01299 3.71197C6.72563 2.93596 7.69218 2.5 8.7 2.5H11.2333V4.56897M8.7 19.0517V22.5M16.3 19.0517C17.3078 19.0517 18.2744 18.6158 18.987 17.8398C19.6996 17.0637 20.1 16.0112 20.1 14.9138V12.1552M16.3 19.0517V22.5M9.33333 6.63793H13.1333"
                        stroke="var(--c-primary)"
                      />
                    </svg>

                    <p>{{ property.bathroom }} Baths</p>
                  </div>

                  <div class="tw-flex tw-items-center tw-gap-2">
                    <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M3 16.4001V19.1001M4.8 10.1001V8.30006C4.8 7.82267 4.98964 7.36483 5.32721 7.02727C5.66477 6.6897 6.12261 6.50006 6.6 6.50006H17.4C17.8774 6.50006 18.3352 6.6897 18.6728 7.02727C19.0104 7.36483 19.2 7.82267 19.2 8.30006V10.1001"
                        stroke="var(--c-primary)"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M21 16.4001V19.1001M19.2 10.1001C18.7226 10.1001 18.2648 10.2897 17.9272 10.6273C17.5896 10.9649 17.4 11.4227 17.4 11.9001V13.7001H6.6V11.9001C6.6 11.4227 6.41036 10.9649 6.07279 10.6273C5.73523 10.2897 5.27739 10.1001 4.8 10.1001C4.32261 10.1001 3.86477 10.2897 3.52721 10.6273C3.18964 10.9649 3 11.4227 3 11.9001V17.3001H21V11.9001C21 11.4227 20.8104 10.9649 20.4728 10.6273C20.1352 10.2897 19.6774 10.1001 19.2 10.1001Z"
                        stroke="var(--c-primary)"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>

                    <p>{{ property.reception }} Reception</p>
                  </div>
                </div>
              </div>
            </div>
            <div
              class="tw-col-span-12 tw-flex tw-flex-col tw-justify-between lg:tw-col-span-5 lg:tw-items-end lg:tw-justify-end lg:tw-gap-8"
            >
              <div
                class="tw-mt-5 tw-flex tw-w-full tw-items-center tw-justify-between max-lg:tw-pt-4 lg:tw-justify-end lg:tw-gap-8"
              >
                <div v-if="property.price" class="tw-flex tw-flex-col lg:tw-items-end">
                  <h4 v-if="property.price.type.name" class="tw-mb-4 tw-uppercase">
                    {{ property.price.type.name }}
                  </h4>
                  <h2 style="color: var(--c-primary) !important">
                    {{ property.price.price }}
                  </h2>
                </div>
              </div>
              <button
                v-if="!property?.is_locked"
                class="n-primary tw-mt-12 tw-w-full tw-self-start md:tw-w-auto lg:tw-mt-6 lg:tw-self-end"
                @click="onSendLead()"
              >
                BOOK A VIEWING
              </button>
            </div>
          </div>
        </div>
        <div v-if="featuredVideo && matterPort" class="tw-mt-8 tw-flex tw-flex-col tw-gap-6 lg:tw-flex-row">
          <div class="tw-aspect-video tw-w-full lg:tw-w-1/2">
            <library-iframe
              class="tw-inset-0"
              :src="featuredVideo"
              frameborder="0"
              allowfullscreen
              :blur="imageBlurFilter"
              :pre-market-blur-text="preMarketBlurText"
            ></library-iframe>
          </div>
          <div class="tw-aspect-video tw-w-full lg:tw-w-1/2">
            <library-iframe
              class="tw-inset-0"
              :src="matterPort"
              frameborder="0"
              allowfullscreen
              :blur="imageBlurFilter"
              :pre-market-blur-text="preMarketBlurText"
            ></library-iframe>
          </div>
        </div>
      </div>
    </section>

    <!-- PROPERTY DETAIL -->
    <template v-if="!property?.is_locked">
      <section class="!tw-pt-0" style="background-color: var(--c-section_primary)">
        <div class="container">
          <div class="tw-grid tw-grid-cols-12 md:tw-gap-x-10">
            <div class="tw-col-span-12 tw-flex tw-flex-col tw-gap-y-12 lg:tw-col-span-7 xl:tw-col-span-8">
              <div v-if="featuredVideo && !matterPort" class="tw-mt-8 tw-flex tw-flex-col tw-gap-6 lg:tw-flex-row">
                <div class="tw-aspect-video tw-w-full">
                  <library-iframe
                    class="tw-inset-0"
                    :src="featuredVideo"
                    frameborder="0"
                    allowfullscreen
                    :blur="imageBlurFilter"
                    :pre-market-blur-text="preMarketBlurText"
                  ></library-iframe>
                </div>
              </div>
              <div v-if="!featuredVideo && matterPort" class="tw-mt-8 tw-flex tw-flex-col tw-gap-6 lg:tw-flex-row">
                <div class="tw-aspect-video tw-w-full">
                  <library-iframe
                    class="tw-inset-0"
                    :src="matterPort"
                    frameborder="0"
                    allowfullscreen
                    :blur="imageBlurFilter"
                    :pre-market-blur-text="preMarketBlurText"
                  ></library-iframe>
                </div>
              </div>

              <div class="tw-my-6 tw-w-full">
                <Theme7ComponentsAccordion
                  class="tw-w-full"
                  :items="propertyAccordionItemsV2"
                  :allow-multiple="false"
                  :show-numbers="false"
                  :initial-open-items="company.company_key === 'harrisandwood' ? [0] : []"
                  @accordion-toggle="onAccordionToggle"
                >
                  <!-- Floor Plan Slot -->
                  <template #floor_plan="{ item, isActive }">
                    <div class="tw-mt-8">
                      <floor-plan v-if="isActive" :data="property.floor_plans" :component="component" />
                    </div>
                  </template>

                  <!-- Property Information Slot -->
                  <template v-if="company.company_key !== 'harrisandwood'" #property_information="{ item, isActive }">
                    <div class="tw-mt-8">
                      <library-text class="tw-text-sm" :html="property.description"></library-text>

                      <!-- amenties -->
                      <div
                        class="tw-mt-4 tw-flex tw-flex-col tw-gap-4 md:tw-mt-8 md:tw-flex-row md:tw-flex-wrap md:tw-gap-6"
                      >
                        <div
                          v-for="criteria in property.criteria_list"
                          :key="criteria.id"
                          class="tw-flex tw-gap-4 tw-p-4"
                          style="background-color: var(--c-section_primary); border-radius: var(--rounded)"
                        >
                          <span v-if="criteria.title === 'Parking'">
                            <svg
                              width="48"
                              height="49"
                              viewBox="0 0 48 49"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M45 21.5955H42.7312L37.4231 9.65358C37.2168 9.18982 36.8805 8.79581 36.4549 8.51927C36.0293 8.24273 35.5326 8.09552 35.025 8.09546H12.975C12.4674 8.09552 11.9707 8.24273 11.5451 8.51927C11.1195 8.79581 10.7832 9.18982 10.5769 9.65358L5.26875 21.5955H3C2.70163 21.5955 2.41548 21.714 2.2045 21.925C1.99353 22.1359 1.875 22.4221 1.875 22.7205C1.875 23.0188 1.99353 23.305 2.2045 23.516C2.41548 23.7269 2.70163 23.8455 3 23.8455H4.875V39.2205C4.875 39.9167 5.15156 40.5843 5.64384 41.0766C6.13613 41.5689 6.80381 41.8455 7.5 41.8455H12C12.6962 41.8455 13.3639 41.5689 13.8562 41.0766C14.3484 40.5843 14.625 39.9167 14.625 39.2205V35.8455H33.375V39.2205C33.375 39.9167 33.6516 40.5843 34.1438 41.0766C34.6361 41.5689 35.3038 41.8455 36 41.8455H40.5C41.1962 41.8455 41.8639 41.5689 42.3562 41.0766C42.8484 40.5843 43.125 39.9167 43.125 39.2205V23.8455H45C45.2984 23.8455 45.5845 23.7269 45.7955 23.516C46.0065 23.305 46.125 23.0188 46.125 22.7205C46.125 22.4221 46.0065 22.1359 45.7955 21.925C45.5845 21.714 45.2984 21.5955 45 21.5955ZM12.6319 10.5686C12.6613 10.5021 12.7094 10.4457 12.7703 10.4061C12.8312 10.3665 12.9023 10.3454 12.975 10.3455H35.025C35.0977 10.3454 35.1688 10.3665 35.2297 10.4061C35.2906 10.4457 35.3387 10.5021 35.3681 10.5686L40.2694 21.5955H7.73063L12.6319 10.5686ZM12.375 39.2205C12.375 39.3199 12.3355 39.4153 12.2652 39.4856C12.1948 39.556 12.0995 39.5955 12 39.5955H7.5C7.40054 39.5955 7.30516 39.556 7.23483 39.4856C7.16451 39.4153 7.125 39.3199 7.125 39.2205V35.8455H12.375V39.2205ZM40.5 39.5955H36C35.9005 39.5955 35.8052 39.556 35.7348 39.4856C35.6645 39.4153 35.625 39.3199 35.625 39.2205V35.8455H40.875V39.2205C40.875 39.3199 40.8355 39.4153 40.7652 39.4856C40.6948 39.556 40.5995 39.5955 40.5 39.5955ZM40.875 33.5955H7.125V23.8455H40.875V33.5955ZM10.875 28.7205C10.875 28.4221 10.9935 28.1359 11.2045 27.925C11.4155 27.714 11.7016 27.5955 12 27.5955H15C15.2984 27.5955 15.5845 27.714 15.7955 27.925C16.0065 28.1359 16.125 28.4221 16.125 28.7205C16.125 29.0188 16.0065 29.305 15.7955 29.516C15.5845 29.7269 15.2984 29.8455 15 29.8455H12C11.7016 29.8455 11.4155 29.7269 11.2045 29.516C10.9935 29.305 10.875 29.0188 10.875 28.7205ZM31.875 28.7205C31.875 28.4221 31.9935 28.1359 32.2045 27.925C32.4155 27.714 32.7016 27.5955 33 27.5955H36C36.2984 27.5955 36.5845 27.714 36.7955 27.925C37.0065 28.1359 37.125 28.4221 37.125 28.7205C37.125 29.0188 37.0065 29.305 36.7955 29.516C36.5845 29.7269 36.2984 29.8455 36 29.8455H33C32.7016 29.8455 32.4155 29.7269 32.2045 29.516C31.9935 29.305 31.875 29.0188 31.875 28.7205Z"
                                fill="var(--c-primary)"
                              />
                            </svg>
                          </span>

                          <span v-else-if="criteria.title === 'Sewerage'">
                            <svg
                              width="48"
                              height="49"
                              viewBox="0 0 48 49"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M43.5 20.0955H38.625V10.3455H43.5C43.7984 10.3455 44.0845 10.2269 44.2955 10.016C44.5065 9.80498 44.625 9.51883 44.625 9.22046C44.625 8.92209 44.5065 8.63594 44.2955 8.42496C44.0845 8.21399 43.7984 8.09546 43.5 8.09546H38.3681C38.1555 7.6472 37.8202 7.26837 37.4011 7.00289C36.9819 6.7374 36.4961 6.59614 36 6.59546H33C32.5039 6.59614 32.0181 6.7374 31.5989 7.00289C31.1798 7.26837 30.8445 7.6472 30.6319 8.09546H27C21.9296 8.10141 17.0685 10.1183 13.4832 13.7036C9.89782 17.289 7.88095 22.15 7.875 27.2205V30.8523C7.42674 31.065 7.04791 31.4003 6.78243 31.8194C6.51694 32.2385 6.37568 32.7243 6.375 33.2205V36.2205C6.37568 36.7166 6.51694 37.2024 6.78243 37.6215C7.04791 38.0406 7.42674 38.376 7.875 38.5886V43.7205C7.875 44.0188 7.99353 44.305 8.2045 44.516C8.41548 44.7269 8.70163 44.8455 9 44.8455C9.29837 44.8455 9.58452 44.7269 9.7955 44.516C10.0065 44.305 10.125 44.0188 10.125 43.7205V38.8455H19.875V43.7205C19.875 44.0188 19.9935 44.305 20.2045 44.516C20.4155 44.7269 20.7016 44.8455 21 44.8455C21.2984 44.8455 21.5845 44.7269 21.7955 44.516C22.0065 44.305 22.125 44.0188 22.125 43.7205V38.5886C22.5733 38.376 22.9521 38.0406 23.2176 37.6215C23.4831 37.2024 23.6243 36.7166 23.625 36.2205V33.2205C23.6243 32.7243 23.4831 32.2385 23.2176 31.8194C22.9521 31.4003 22.5733 31.065 22.125 30.8523V27.2205C22.125 25.9275 22.6386 24.6876 23.5529 23.7733C24.4671 22.8591 25.7071 22.3455 27 22.3455H30.6319C30.8445 22.7937 31.1798 23.1726 31.5989 23.438C32.0181 23.7035 32.5039 23.8448 33 23.8455H36C36.4961 23.8448 36.9819 23.7035 37.4011 23.438C37.8202 23.1726 38.1555 22.7937 38.3681 22.3455H43.5C43.7984 22.3455 44.0845 22.2269 44.2955 22.016C44.5065 21.805 44.625 21.5188 44.625 21.2205C44.625 20.9221 44.5065 20.6359 44.2955 20.425C44.0845 20.214 43.7984 20.0955 43.5 20.0955ZM21 32.8455C21.0995 32.8455 21.1948 32.885 21.2652 32.9553C21.3355 33.0256 21.375 33.121 21.375 33.2205V36.2205C21.375 36.3199 21.3355 36.4153 21.2652 36.4856C21.1948 36.556 21.0995 36.5955 21 36.5955H9C8.90054 36.5955 8.80516 36.556 8.73483 36.4856C8.66451 36.4153 8.625 36.3199 8.625 36.2205V33.2205C8.625 33.121 8.66451 33.0256 8.73483 32.9553C8.80516 32.885 8.90054 32.8455 9 32.8455H21ZM19.875 27.2205V30.5955H10.125V27.2205C10.13 22.7465 11.9095 18.4571 15.0731 15.2935C18.2367 12.1299 22.526 10.3504 27 10.3455H30.375V20.0955H27C25.1103 20.0955 23.2981 20.8461 21.9619 22.1823C20.6257 23.5185 19.875 25.3308 19.875 27.2205ZM36 21.5955H33C32.9005 21.5955 32.8052 21.556 32.7348 21.4856C32.6645 21.4153 32.625 21.3199 32.625 21.2205V9.22046C32.625 9.121 32.6645 9.02562 32.7348 8.95529C32.8052 8.88497 32.9005 8.84546 33 8.84546H36C36.0995 8.84546 36.1948 8.88497 36.2652 8.95529C36.3355 9.02562 36.375 9.121 36.375 9.22046V21.2205C36.375 21.3199 36.3355 21.4153 36.2652 21.4856C36.1948 21.556 36.0995 21.5955 36 21.5955Z"
                                fill="var(--c-primary)"
                              />
                            </svg>
                          </span>

                          <span v-else-if="criteria.title === 'Water'">
                            <svg
                              width="48"
                              height="49"
                              viewBox="0 0 48 49"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M5 34.6805V32.6045C6.036 32.4765 6.84267 32.1365 7.42 31.5845C7.99867 31.0338 9.092 30.7585 10.7 30.7585C12.3853 30.7585 13.5747 31.0918 14.268 31.7585C14.9613 32.4251 15.9847 32.7585 17.338 32.7585C18.7073 32.7585 19.7387 32.4251 20.432 31.7585C21.1253 31.0918 22.3147 30.7585 24 30.7585C25.6693 30.7585 26.8587 31.0918 27.568 31.7585C28.2773 32.4251 29.3087 32.7585 30.662 32.7585C32.0313 32.7585 33.0587 32.4251 33.744 31.7585C34.4307 31.0918 35.616 30.7585 37.3 30.7585C38.908 30.7585 40.0013 31.0345 40.58 31.5865C41.1573 32.1371 41.964 32.4771 43 32.6065V34.6825C41.792 34.5278 40.8333 34.1685 40.124 33.6045C39.4147 33.0405 38.4733 32.7585 37.3 32.7585C35.972 32.7585 34.9547 33.0918 34.248 33.7585C33.5413 34.4251 32.346 34.7585 30.662 34.7585C28.9927 34.7585 27.8033 34.4251 27.094 33.7585C26.3847 33.0918 25.3533 32.7591 24 32.7605C22.6307 32.7605 21.5993 33.0938 20.906 33.7605C20.2127 34.4271 19.0233 34.7605 17.338 34.7605C15.6527 34.7605 14.4613 34.4271 13.764 33.7605C13.0667 33.0938 12.0453 32.7605 10.7 32.7605C9.484 32.7605 8.54867 33.0425 7.894 33.6065C7.23933 34.1718 6.27467 34.5311 5 34.6845M5 27.1445V25.0685C6.036 24.9405 6.84267 24.6005 7.42 24.0485C7.99867 23.4978 9.092 23.2225 10.7 23.2225C12.3693 23.2225 13.5547 23.5558 14.256 24.2225C14.9573 24.8891 15.9847 25.2225 17.338 25.2225C18.7073 25.2225 19.7387 24.8891 20.432 24.2225C21.1253 23.5558 22.3147 23.2218 24 23.2205C25.6693 23.2205 26.856 23.5538 27.56 24.2205C28.264 24.8871 29.2907 25.2205 30.64 25.2205C32.008 25.2205 33.0387 24.8871 33.732 24.2205C34.4253 23.5538 35.6147 23.2205 37.3 23.2205C38.892 23.2205 39.9853 23.4965 40.58 24.0485C41.1733 24.5991 41.98 24.9385 43 25.0665V27.1425C41.7773 26.9891 40.8153 26.6305 40.114 26.0665C39.4127 25.5025 38.4747 25.2205 37.3 25.2205C35.972 25.2205 34.9547 25.5538 34.248 26.2205C33.5413 26.8871 32.346 27.2205 30.662 27.2205C28.9927 27.2205 27.8033 26.8871 27.094 26.2205C26.386 25.5538 25.3547 25.2205 24 25.2205C22.6307 25.2205 21.6033 25.5538 20.918 26.2205C20.2313 26.8871 19.046 27.2205 17.362 27.2205C15.678 27.2205 14.478 26.8871 13.762 26.2205C13.046 25.5538 12.0253 25.2205 10.7 25.2205C9.5 25.2205 8.56467 25.5025 7.894 26.0665C7.22333 26.6305 6.25867 26.9898 5 27.1445ZM5 19.6045V17.5285C6.036 17.4005 6.84267 17.0605 7.42 16.5085C7.99867 15.9578 9.092 15.6825 10.7 15.6825C12.3693 15.6825 13.5547 16.0158 14.256 16.6825C14.9573 17.3491 15.9847 17.6825 17.338 17.6825C18.7073 17.6825 19.7387 17.3491 20.432 16.6825C21.1253 16.0158 22.3147 15.6818 24 15.6805C25.6693 15.6805 26.856 16.0138 27.56 16.6805C28.264 17.3471 29.2907 17.6805 30.64 17.6805C32.008 17.6805 33.0387 17.3471 33.732 16.6805C34.4253 16.0138 35.6147 15.6805 37.3 15.6805C38.892 15.6805 39.9853 15.9558 40.58 16.5065C41.1733 17.0585 41.98 17.3985 43 17.5265V19.6025C41.7773 19.4491 40.8153 19.0905 40.114 18.5265C39.4127 17.9625 38.4747 17.6805 37.3 17.6805C35.972 17.6805 34.9547 18.0138 34.248 18.6805C33.5413 19.3471 32.346 19.6805 30.662 19.6805C28.9927 19.6805 27.8033 19.3471 27.094 18.6805C26.386 18.0138 25.3547 17.6805 24 17.6805C22.6307 17.6805 21.6033 18.0138 20.918 18.6805C20.2313 19.3471 19.046 19.6805 17.362 19.6805C15.678 19.6805 14.478 19.3471 13.762 18.6805C13.046 18.0138 12.0253 17.6805 10.7 17.6805C9.5 17.6805 8.552 17.9625 7.856 18.5265C7.16 19.0905 6.208 19.4498 5 19.6045Z"
                                fill="var(--c-primary)"
                              />
                            </svg>
                          </span>
                          <span v-else>
                            <svg
                              width="48"
                              height="49"
                              viewBox="0 0 48 49"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <g clip-path="url(#clip0_481_37820)">
                                <path
                                  d="M44.9467 23.2738L24.9467 3.27383C24.6969 3.0255 24.359 2.88611 24.0067 2.88611C23.6545 2.88611 23.3165 3.0255 23.0667 3.27383L3.0667 23.2738C2.84827 23.5289 2.73413 23.857 2.74709 24.1926C2.76005 24.5281 2.89916 24.8465 3.13662 25.0839C3.37408 25.3214 3.6924 25.4605 4.02797 25.4734C4.36353 25.4864 4.69163 25.3723 4.9467 25.1538L24 6.1005L43.0534 25.1672C43.3084 25.3856 43.6365 25.4997 43.9721 25.4868C44.3077 25.4738 44.626 25.3347 44.8635 25.0972C45.1009 24.8598 45.24 24.5415 45.253 24.2059C45.2659 23.8703 45.1518 23.5422 44.9334 23.2872L44.9467 23.2738Z"
                                  fill="var(--c-primary)"
                                />
                                <path
                                  d="M37.3333 42.8872H30.6667V29.5538H17.3333V42.8872H10.6667V24.2205L8 26.8872V42.8872C8 43.5944 8.28095 44.2727 8.78105 44.7728C9.28115 45.2729 9.95942 45.5538 10.6667 45.5538H20V32.2205H28V45.5538H37.3333C38.0406 45.5538 38.7189 45.2729 39.219 44.7728C39.7191 44.2727 40 43.5944 40 42.8872V26.5672L37.3333 23.9005V42.8872Z"
                                  fill="var(--c-primary)"
                                />
                              </g>
                              <defs>
                                <clipPath id="clip0_481_37820">
                                  <rect width="48" height="48" fill="white" transform="translate(0 0.220459)" />
                                </clipPath>
                              </defs>
                            </svg>
                          </span>
                          <div>
                            <small class="n-title-primary tw-uppercase">{{ criteria.title }}</small>
                            <p>{{ criteria.value }}</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </template>

                  <!-- Features Slot -->
                  <template #features="{ item, isActive }">
                    <div v-if="property?.features" class="tw-mt-8 tw-grid tw-grid-cols-12 tw-gap-4">
                      <div
                        v-for="(feature, index) in property.features"
                        :key="`property-feature-${index}`"
                        class="tw-col-span-12 tw-flex tw-items-start tw-gap-x-3 md:tw-col-span-6 xl:tw-col-span-4"
                      >
                        <span>
                          <svg
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M9.5501 18L3.8501 12.3L5.2751 10.875L9.5501 15.15L18.7251 5.97498L20.1501 7.39998L9.5501 18Z"
                              fill="var(--c-primary)"
                            />
                          </svg>
                        </span>
                        <library-text class="tw-text-sm tw-font-semibold tw-uppercase" :text="feature"></library-text>
                      </div>
                    </div>
                  </template>

                  <!-- Map Slot -->
                  <template #map="{ item, isActive }">
                    <div class="tw-mt-8">
                      <neuron-google-map
                        v-if="
                          isActive && property.map_position && property.map_position.lat && property.map_position.lng
                        "
                        v-model:map-center-position="property.map_position"
                        :component="component"
                        :marker-color="markerColor"
                      />
                    </div>
                  </template>

                  <!-- EPC Slot -->
                  <template #epc="{ item, isActive }">
                    <div class="tw-mt-8">
                      <epc :data="property.epcs" id="epc" :component="component" />
                    </div>
                  </template>
                </Theme7ComponentsAccordion>
              </div>
              <div
                v-if="isMortgageCalculatorVisible && property?.is_rent === false"
                class="mortgage tw-mt-12 lg:tw-mt-24"
                :class="property.is_rent ? 'rent-property' : 'sales-property'"
              >
                <library-tools-mortgage-calculator :default-price="property.price.numberPrice" />
              </div>

              <div
                v-if="isStampDutyCalculatorVisible && property?.is_rent === false"
                class="stamp tw-mt-12 lg:tw-mt-24"
                :class="property.is_rent ? 'rent-property' : 'sales-property'"
              >
                <library-tools-stamp-duty-calculator :default-price="property.price.numberPrice" />
              </div>
            </div>
            <div class="tw-col-span-12 tw-pt-6 lg:tw-col-span-5 xl:tw-col-span-4">
              <div v-if="sidebarComponents && sidebarComponents.length" class="tw-flex tw-flex-col tw-gap-4">
                <div v-if="vars.viewingOptionsBool">
                  <div
                    class="tw-relative tw-flex tw-w-full tw-flex-col tw-justify-center tw-gap-5 tw-px-4 tw-py-9 tw-text-start"
                    :style="`background-color: var(--c-sidebar-card); border-radius: var(--rounded);`"
                  >
                    <h4>{{ vars.viewingOptionsTitleText }}</h4>
                    <p v-if="vars.viewingOptionsDescriptionText">
                      {{ vars.viewingOptionsDescriptionText }}
                    </p>
                    <div class="tw-mt-2 tw-flex tw-flex-col tw-gap-4">
                      <button
                        v-if="featuredVideo"
                        :class="`n-${vars.viewingOptionsButton1TypeText} tw-w-fit`"
                        @click="onVidePopup()"
                      >
                        {{ vars.viewingOptionsButton1LabelText }}
                      </button>
                      <button :class="`n-${vars.viewingOptionsButton2TypeText} tw-w-fit`" @click="onSendLead()">
                        {{ vars.viewingOptionsButton2LabelText }}
                      </button>
                    </div>
                  </div>
                </div>
                <theme7-available-components-for-sidebar
                  key="property-detail-sidebar"
                  key-prefix="property-detail-sidebar"
                  :specific-components="sidebarComponents"
                />
              </div>
            </div>
          </div>
        </div>

        <full-screen-gallery
          v-if="fullScreenPopupConfig.is_active && activeMedia && property && property.medias"
          v-model:active-media-index="activeMediaIndex"
          :component="component"
          :active-media="activeMedia"
          :count-of-medias="property.medias.length"
          @close="(closeLightbox(), toggleHeader())"
        />

        <popup :config="sendLeadPopupConfig" custom-width="800px">
          <template #content>
            <send-lead
              v-if="sendLeadPopupConfig.isActive"
              :property="property"
              @on-success="onSuccess"
              @close="sendLeadPopupConfig.isActive = false"
            />
          </template>
        </popup>

        <popup :config="videoPopupConfig" v-if="videoPopupConfig.videoPopupSrc" custom-width="500px" @close="stopVideo">
          <template #content>
            <div class="tw-relative tw-pt-6">
              <div class="tw-aspect-[9/16] tw-h-full tw-w-full">
                <library-iframe
                  class="tw-absolute tw-inset-0 tw-h-full tw-w-full"
                  :src="videoPopupConfig.videoPopupSrc"
                  frameborder="0"
                  allowfullscreen
                  :blur="imageBlurFilter"
                  :pre-market-blur-text="preMarketBlurText"
                ></library-iframe>
              </div>
            </div>
          </template>
        </popup>

        <popup :config="successModalConfig" @close="onSuccessModalClosed()">
          <template #content>
            <success :text="successPopupText" />
          </template>
        </popup>
      </section>
    </template>
    <template v-else-if="property?.is_locked">
      <section class="!tw-pt-0" style="background-color: var(--c-section_primary)">
        <div class="container">
          <library-login />
        </div>
      </section>
    </template>
  </div>

  <div
    class="property-detail layout-pb-lg"
    v-if="variants.v3 === variant"
    :style="`background-color: var(--c-${vars.backgroundColor});`"
  >
    <section class="layout-pb-lg relative !tw-block !tw-pt-44">
      <div class="container">
        <!-- Slider wrapper with overflow hidden -->
        <div data-anim="slide-up delay-1" class="tabs__content js-tabs-content tw-overflow-hidden">
          <div class="tabs__pane -tab-item-1 is-tab-el-active">
            <div class="tw--mx-4 md:tw--mx-6 lg:tw--mx-8">
              <div class="row tw-mx-0">
                <div class="col-12 tw-px-0">
                  <div
                    class="relative js-section-slider"
                    data-anim="slide-left delay-1"
                    data-gap="0"
                    data-slider-cols="xl-1 lg-1 md-1 sm-1 base-1"
                    style="overflow: hidden"
                  >
                    <div class="swiper-wrapper">
                      <div
                        v-for="(image, index) in maxPhotosToShow"
                        :key="`property-detail-image-${index}`"
                        class="swiper-slide relative"
                        :style="{
                          padding: 0,
                          margin: 0,
                          transform: 'scale(1) !important',
                        }"
                      >
                        <div class="ratio ratio-16:9 !tw-z-0">
                          <library-image
                            v-if="image.isImage"
                            :src="image.background"
                            alt="image"
                            image-class="img-ratio !tw-z-0 tw-cursor-grab"
                            @click="(onClickedImage(image), toggleHeader())"
                            :blur="imageBlurFilter"
                            :pre-market-blur-text="preMarketBlurText"
                          />
                          <div
                            v-if="property && property.medias"
                            class="nc-first-image-overlay-item"
                            style="
                              position: absolute;
                              bottom: 0.1rem;
                              right: 1rem;
                              z-index: 999;
                              transform: translate(-50%, -50%);
                            "
                          >
                            <div
                              style="
                                border-radius: var(--rounded-sm);
                                color: var(--c-primary);
                                background-color: var(--c-section_primary);
                              "
                              @click="(onClickedImage(image), toggleHeader())"
                              class="tw-text-md tw-px-2 tw-py-1"
                            >
                              {{ index + 1 }}/{{ maxPhotosToShow.length }}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <!-- Navigation buttons - Centered on image -->
                    <button
                      class="sliderNav -prev js-prev n-link nav-secondary tw-absolute tw-left-8 tw-top-1/2 tw-z-20 tw--translate-y-1/2 md:tw-left-32 lg:tw-left-60"
                      @click="slidePrev"
                    >
                      <i class="icon-left-arrow"></i>
                    </button>

                    <button
                      class="sliderNav -next js-next n-link nav-secondary tw-absolute tw-right-8 tw-top-1/2 tw-z-20 tw--translate-y-1/2 md:tw-right-32 lg:tw-right-60"
                      @click="slideNext"
                    >
                      <i class="icon-right-arrow"></i>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section v-if="property" class="layout-pb-md" style="background-color: var(--c-section_primary)">
      <!-- GALLERY: END -->

      <div class="container">
        <div class="property-detail-info tw-flex tw-w-full tw-flex-col">
          <div class="tw-grid tw-grid-cols-12 tw-items-start tw-justify-between">
            <div class="tw-col-span-12 tw-flex tw-flex-col lg:tw-col-span-7">
              <h3 style="color: var(--c-text_primary)">{{ property.advert_heading }}</h3>
              <div class="address tw-mt-5 tw-flex tw-items-center tw-gap-1">
                <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M11.5 12.5C10.8078 12.5 10.1311 12.2947 9.55551 11.9101C8.97993 11.5256 8.53133 10.9789 8.26642 10.3394C8.00152 9.69985 7.9322 8.99612 8.06725 8.31719C8.2023 7.63825 8.53564 7.01461 9.02513 6.52513C9.51461 6.03564 10.1383 5.7023 10.8172 5.56725C11.4961 5.4322 12.1999 5.50152 12.8394 5.76642C13.4789 6.03133 14.0256 6.47993 14.4101 7.05551C14.7947 7.63108 15 8.30777 15 9C14.9989 9.92792 14.6298 10.8175 13.9736 11.4736C13.3175 12.1298 12.4279 12.4989 11.5 12.5ZM11.5 6.9C11.0847 6.9 10.6786 7.02316 10.3333 7.25392C9.98796 7.48467 9.7188 7.81264 9.55985 8.19637C9.40091 8.58009 9.35932 9.00233 9.44035 9.40969C9.52138 9.81705 9.72139 10.1912 10.0151 10.4849C10.3088 10.7786 10.683 10.9786 11.0903 11.0596C11.4977 11.1407 11.9199 11.0991 12.3036 10.9401C12.6874 10.7812 13.0153 10.512 13.2461 10.1667C13.4768 9.82136 13.6 9.41534 13.6 9C13.5994 8.44322 13.378 7.9094 12.9843 7.51569C12.5906 7.12199 12.0568 6.90056 11.5 6.9Z"
                    fill="var(--c-secondary)"
                  />
                  <path
                    d="M11.5 21.5L5.74819 14.3936C5.66826 14.2869 5.58917 14.1795 5.51091 14.0714C4.5289 12.7153 3.99818 11.0594 4 9.35714C4 7.2733 4.79018 5.2748 6.1967 3.8013C7.60322 2.3278 9.51088 1.5 11.5 1.5C13.4891 1.5 15.3968 2.3278 16.8033 3.8013C18.2098 5.2748 19 7.2733 19 9.35714C19.0016 11.0585 18.4711 12.7136 17.4898 14.0693L17.4891 14.0714C17.4891 14.0714 17.2845 14.3529 17.2539 14.3907L11.5 21.5ZM6.59978 13.2107C6.59978 13.2107 6.75864 13.4307 6.79478 13.4779L11.5 19.2914L16.2114 13.47C16.2414 13.4307 16.4009 13.2093 16.4016 13.2086C17.2042 12.1008 17.638 10.7479 17.6364 9.35714C17.6364 7.65218 16.9899 6.01705 15.8391 4.81146C14.6883 3.60587 13.1275 2.92857 11.5 2.92857C9.87254 2.92857 8.31173 3.60587 7.16094 4.81146C6.01015 6.01705 5.36364 7.65218 5.36364 9.35714C5.36196 10.7488 5.79622 12.1026 6.59978 13.2107Z"
                    fill="var(--c-secondary)"
                  />
                </svg>

                <p class="tw-capitalize" style="color: var(--c-text_primary)">{{ property.display_address }}</p>
              </div>
              <div v-if="!property.is_locked" class="tw-mt-5 tw-flex tw-items-center tw-gap-1">
                <div class="rooms tw-flex tw-flex-row tw-items-center tw-gap-4">
                  <div class="tw-flex tw-items-center tw-gap-2">
                    <svg
                      width="24"
                      height="25"
                      viewBox="0 0 24 25"
                      fill="var(--c-primary)"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M3 18.5V11.5H4V7.5H20V11.5H21V18.5H20V16.5H4V18.5H3ZM12.5 11.5H19V8.5H12.5V11.5ZM5 11.5H11.5V8.5H5V11.5ZM4 15.5H20V12.5H4V15.5Z"
                        fill="var(--c-secondary)"
                      />
                    </svg>
                    <p>{{ property.bedroom }} Beds</p>
                  </div>

                  <div class="tw-flex tw-items-center tw-gap-2">
                    <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M3 12.1552H22M8.7 19.0517H16.3M8.7 19.0517C7.69218 19.0517 6.72563 18.6158 6.01299 17.8398C5.30036 17.0637 4.9 16.0112 4.9 14.9138V6.63793C4.9 5.54048 5.30036 4.48798 6.01299 3.71197C6.72563 2.93596 7.69218 2.5 8.7 2.5H11.2333V4.56897M8.7 19.0517V22.5M16.3 19.0517C17.3078 19.0517 18.2744 18.6158 18.987 17.8398C19.6996 17.0637 20.1 16.0112 20.1 14.9138V12.1552M16.3 19.0517V22.5M9.33333 6.63793H13.1333"
                        stroke="var(--c-secondary)"
                      />
                    </svg>

                    <p>{{ property.bathroom }} Baths</p>
                  </div>

                  <div class="tw-flex tw-items-center tw-gap-2">
                    <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M3 16.4001V19.1001M4.8 10.1001V8.30006C4.8 7.82267 4.98964 7.36483 5.32721 7.02727C5.66477 6.6897 6.12261 6.50006 6.6 6.50006H17.4C17.8774 6.50006 18.3352 6.6897 18.6728 7.02727C19.0104 7.36483 19.2 7.82267 19.2 8.30006V10.1001"
                        stroke="var(--c-secondary)"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M21 16.4001V19.1001M19.2 10.1001C18.7226 10.1001 18.2648 10.2897 17.9272 10.6273C17.5896 10.9649 17.4 11.4227 17.4 11.9001V13.7001H6.6V11.9001C6.6 11.4227 6.41036 10.9649 6.07279 10.6273C5.73523 10.2897 5.27739 10.1001 4.8 10.1001C4.32261 10.1001 3.86477 10.2897 3.52721 10.6273C3.18964 10.9649 3 11.4227 3 11.9001V17.3001H21V11.9001C21 11.4227 20.8104 10.9649 20.4728 10.6273C20.1352 10.2897 19.6774 10.1001 19.2 10.1001Z"
                        stroke="var(--c-secondary)"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>

                    <p>{{ property.reception }} Reception</p>
                  </div>
                </div>
              </div>
            </div>
            <div
              class="tw-col-span-12 tw-flex tw-flex-col tw-justify-between lg:tw-col-span-5 lg:tw-items-end lg:tw-justify-end lg:tw-gap-8"
            >
              <div
                class="tw-mt-5 tw-flex tw-w-full tw-items-center tw-justify-between max-lg:tw-pt-4 lg:tw-justify-end lg:tw-gap-8"
              >
                <div v-if="property.price" class="tw-flex tw-flex-col lg:tw-items-end">
                  <h4 v-if="property.price.type.name" class="tw-mb-4 tw-uppercase">
                    {{ property.price.type.name }}
                  </h4>
                  <h2 style="color: var(--c-primary) !important">
                    {{ property.price.price }}
                  </h2>
                </div>
              </div>
              <button
                v-if="!property?.is_locked"
                class="n-primary tw-mt-12 tw-w-full tw-self-start md:tw-w-auto lg:tw-mt-6 lg:tw-self-end"
                @click="(onSendLead(), toggleHeader())"
              >
                BOOK A VIEWING
              </button>
            </div>
          </div>
        </div>
        <div v-if="featuredVideo && matterPort" class="tw-mt-8 tw-flex tw-flex-col tw-gap-6 lg:tw-flex-row">
          <div class="tw-aspect-video tw-w-full lg:tw-w-1/2">
            <library-iframe
              class="tw-inset-0"
              :src="featuredVideo"
              frameborder="0"
              allowfullscreen
              :blur="imageBlurFilter"
              :pre-market-blur-text="preMarketBlurText"
            ></library-iframe>
          </div>
          <div class="tw-aspect-video tw-w-full lg:tw-w-1/2">
            <library-iframe
              class="tw-inset-0"
              :src="matterPort"
              frameborder="0"
              allowfullscreen
              :blur="imageBlurFilter"
              :pre-market-blur-text="preMarketBlurText"
            ></library-iframe>
          </div>
        </div>
      </div>
    </section>

    <!-- PROPERTY DETAIL -->
    <template v-if="!property?.is_locked">
      <section class="!tw-pt-0" style="background-color: var(--c-section_primary)">
        <div class="container">
          <div class="tw-grid tw-grid-cols-12 md:tw-gap-x-10">
            <div class="tw-col-span-12 tw-flex tw-flex-col tw-gap-y-12 lg:tw-col-span-7 xl:tw-col-span-8">
              <div v-if="featuredVideo && !matterPort" class="tw-mt-8 tw-flex tw-flex-col tw-gap-6 lg:tw-flex-row">
                <div class="tw-aspect-video tw-w-full">
                  <library-iframe
                    class="tw-inset-0"
                    :src="featuredVideo"
                    frameborder="0"
                    allowfullscreen
                    :blur="imageBlurFilter"
                    :pre-market-blur-text="preMarketBlurText"
                  ></library-iframe>
                </div>
              </div>
              <div v-if="!featuredVideo && matterPort" class="tw-mt-8 tw-flex tw-flex-col tw-gap-6 lg:tw-flex-row">
                <div class="tw-aspect-video tw-w-full">
                  <library-iframe
                    class="tw-inset-0"
                    :src="matterPort"
                    frameborder="0"
                    allowfullscreen
                    :blur="imageBlurFilter"
                    :pre-market-blur-text="preMarketBlurText"
                  ></library-iframe>
                </div>
              </div>

              <div class="tw-my-6 tw-w-full">
                <Theme7ComponentsAccordion
                  class="tw-w-full"
                  :items="propertyAccordionItems"
                  :allow-multiple="false"
                  :show-numbers="false"
                  @accordion-toggle="onAccordionToggle"
                  :style="{ '--color-accent-1': 'var(--c-secondary)' }"
                >
                  <!-- Features Slot -->
                  <template #features="{ item, isActive }">
                    <div v-if="property?.features" class="tw-mt-8 tw-grid tw-grid-cols-12 tw-gap-4">
                      <div
                        v-for="(feature, index) in property.features"
                        :key="`property-feature-${index}`"
                        class="tw-col-span-12 tw-flex tw-items-start tw-gap-x-3 md:tw-col-span-6 xl:tw-col-span-4"
                      >
                        <span>
                          <svg
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M9.5501 18L3.8501 12.3L5.2751 10.875L9.5501 15.15L18.7251 5.97498L20.1501 7.39998L9.5501 18Z"
                              fill="var(--c-secondary)"
                            />
                          </svg>
                        </span>
                        <library-text class="" :text="feature"></library-text>
                      </div>
                    </div>
                  </template>

                  <!-- Property Information Slot -->
                  <template #property_information="{ item, isActive }">
                    <div class="tw-mt-8">
                      <library-text
                        v-if="company.company_key !== 'keystonepmc'"
                        class="tw-text-sm"
                        :html="property.description"
                      ></library-text>

                      <!-- amenties -->
                      <div
                        class="tw-mt-4 tw-flex tw-flex-col tw-gap-4 md:tw-mt-8 md:tw-flex-row md:tw-flex-wrap md:tw-gap-6"
                      >
                        <div
                          v-for="criteria in property.criteria_list"
                          :key="criteria.id"
                          class="tw-flex tw-gap-4 tw-p-4"
                          style="background-color: var(--c-section_primary); border-radius: var(--rounded)"
                        >
                          <span v-if="criteria.title === 'Parking'">
                            <svg
                              width="48"
                              height="49"
                              viewBox="0 0 48 49"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M45 21.5955H42.7312L37.4231 9.65358C37.2168 9.18982 36.8805 8.79581 36.4549 8.51927C36.0293 8.24273 35.5326 8.09552 35.025 8.09546H12.975C12.4674 8.09552 11.9707 8.24273 11.5451 8.51927C11.1195 8.79581 10.7832 9.18982 10.5769 9.65358L5.26875 21.5955H3C2.70163 21.5955 2.41548 21.714 2.2045 21.925C1.99353 22.1359 1.875 22.4221 1.875 22.7205C1.875 23.0188 1.99353 23.305 2.2045 23.516C2.41548 23.7269 2.70163 23.8455 3 23.8455H4.875V39.2205C4.875 39.9167 5.15156 40.5843 5.64384 41.0766C6.13613 41.5689 6.80381 41.8455 7.5 41.8455H12C12.6962 41.8455 13.3639 41.5689 13.8562 41.0766C14.3484 40.5843 14.625 39.9167 14.625 39.2205V35.8455H33.375V39.2205C33.375 39.9167 33.6516 40.5843 34.1438 41.0766C34.6361 41.5689 35.3038 41.8455 36 41.8455H40.5C41.1962 41.8455 41.8639 41.5689 42.3562 41.0766C42.8484 40.5843 43.125 39.9167 43.125 39.2205V23.8455H45C45.2984 23.8455 45.5845 23.7269 45.7955 23.516C46.0065 23.305 46.125 23.0188 46.125 22.7205C46.125 22.4221 46.0065 22.1359 45.7955 21.925C45.5845 21.714 45.2984 21.5955 45 21.5955ZM12.6319 10.5686C12.6613 10.5021 12.7094 10.4457 12.7703 10.4061C12.8312 10.3665 12.9023 10.3454 12.975 10.3455H35.025C35.0977 10.3454 35.1688 10.3665 35.2297 10.4061C35.2906 10.4457 35.3387 10.5021 35.3681 10.5686L40.2694 21.5955H7.73063L12.6319 10.5686ZM12.375 39.2205C12.375 39.3199 12.3355 39.4153 12.2652 39.4856C12.1948 39.556 12.0995 39.5955 12 39.5955H7.5C7.40054 39.5955 7.30516 39.556 7.23483 39.4856C7.16451 39.4153 7.125 39.3199 7.125 39.2205V35.8455H12.375V39.2205ZM40.5 39.5955H36C35.9005 39.5955 35.8052 39.556 35.7348 39.4856C35.6645 39.4153 35.625 39.3199 35.625 39.2205V35.8455H40.875V39.2205C40.875 39.3199 40.8355 39.4153 40.7652 39.4856C40.6948 39.556 40.5995 39.5955 40.5 39.5955ZM40.875 33.5955H7.125V23.8455H40.875V33.5955ZM10.875 28.7205C10.875 28.4221 10.9935 28.1359 11.2045 27.925C11.4155 27.714 11.7016 27.5955 12 27.5955H15C15.2984 27.5955 15.5845 27.714 15.7955 27.925C16.0065 28.1359 16.125 28.4221 16.125 28.7205C16.125 29.0188 16.0065 29.305 15.7955 29.516C15.5845 29.7269 15.2984 29.8455 15 29.8455H12C11.7016 29.8455 11.4155 29.7269 11.2045 29.516C10.9935 29.305 10.875 29.0188 10.875 28.7205ZM31.875 28.7205C31.875 28.4221 31.9935 28.1359 32.2045 27.925C32.4155 27.714 32.7016 27.5955 33 27.5955H36C36.2984 27.5955 36.5845 27.714 36.7955 27.925C37.0065 28.1359 37.125 28.4221 37.125 28.7205C37.125 29.0188 37.0065 29.305 36.7955 29.516C36.5845 29.7269 36.2984 29.8455 36 29.8455H33C32.7016 29.8455 32.4155 29.7269 32.2045 29.516C31.9935 29.305 31.875 29.0188 31.875 28.7205Z"
                                fill="var(--c-primary)"
                              />
                            </svg>
                          </span>

                          <span v-else-if="criteria.title === 'Sewerage'">
                            <svg
                              width="48"
                              height="49"
                              viewBox="0 0 48 49"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M43.5 20.0955H38.625V10.3455H43.5C43.7984 10.3455 44.0845 10.2269 44.2955 10.016C44.5065 9.80498 44.625 9.51883 44.625 9.22046C44.625 8.92209 44.5065 8.63594 44.2955 8.42496C44.0845 8.21399 43.7984 8.09546 43.5 8.09546H38.3681C38.1555 7.6472 37.8202 7.26837 37.4011 7.00289C36.9819 6.7374 36.4961 6.59614 36 6.59546H33C32.5039 6.59614 32.0181 6.7374 31.5989 7.00289C31.1798 7.26837 30.8445 7.6472 30.6319 8.09546H27C21.9296 8.10141 17.0685 10.1183 13.4832 13.7036C9.89782 17.289 7.88095 22.15 7.875 27.2205V30.8523C7.42674 31.065 7.04791 31.4003 6.78243 31.8194C6.51694 32.2385 6.37568 32.7243 6.375 33.2205V36.2205C6.37568 36.7166 6.51694 37.2024 6.78243 37.6215C7.04791 38.0406 7.42674 38.376 7.875 38.5886V43.7205C7.875 44.0188 7.99353 44.305 8.2045 44.516C8.41548 44.7269 8.70163 44.8455 9 44.8455C9.29837 44.8455 9.58452 44.7269 9.7955 44.516C10.0065 44.305 10.125 44.0188 10.125 43.7205V38.8455H19.875V43.7205C19.875 44.0188 19.9935 44.305 20.2045 44.516C20.4155 44.7269 20.7016 44.8455 21 44.8455C21.2984 44.8455 21.5845 44.7269 21.7955 44.516C22.0065 44.305 22.125 44.0188 22.125 43.7205V38.5886C22.5733 38.376 22.9521 38.0406 23.2176 37.6215C23.4831 37.2024 23.6243 36.7166 23.625 36.2205V33.2205C23.6243 32.7243 23.4831 32.2385 23.2176 31.8194C22.9521 31.4003 22.5733 31.065 22.125 30.8523V27.2205C22.125 25.9275 22.6386 24.6876 23.5529 23.7733C24.4671 22.8591 25.7071 22.3455 27 22.3455H30.6319C30.8445 22.7937 31.1798 23.1726 31.5989 23.438C32.0181 23.7035 32.5039 23.8448 33 23.8455H36C36.4961 23.8448 36.9819 23.7035 37.4011 23.438C37.8202 23.1726 38.1555 22.7937 38.3681 22.3455H43.5C43.7984 22.3455 44.0845 22.2269 44.2955 22.016C44.5065 21.805 44.625 21.5188 44.625 21.2205C44.625 20.9221 44.5065 20.6359 44.2955 20.425C44.0845 20.214 43.7984 20.0955 43.5 20.0955ZM21 32.8455C21.0995 32.8455 21.1948 32.885 21.2652 32.9553C21.3355 33.0256 21.375 33.121 21.375 33.2205V36.2205C21.375 36.3199 21.3355 36.4153 21.2652 36.4856C21.1948 36.556 21.0995 36.5955 21 36.5955H9C8.90054 36.5955 8.80516 36.556 8.73483 36.4856C8.66451 36.4153 8.625 36.3199 8.625 36.2205V33.2205C8.625 33.121 8.66451 33.0256 8.73483 32.9553C8.80516 32.885 8.90054 32.8455 9 32.8455H21ZM19.875 27.2205V30.5955H10.125V27.2205C10.13 22.7465 11.9095 18.4571 15.0731 15.2935C18.2367 12.1299 22.526 10.3504 27 10.3455H30.375V20.0955H27C25.1103 20.0955 23.2981 20.8461 21.9619 22.1823C20.6257 23.5185 19.875 25.3308 19.875 27.2205ZM36 21.5955H33C32.9005 21.5955 32.8052 21.556 32.7348 21.4856C32.6645 21.4153 32.625 21.3199 32.625 21.2205V9.22046C32.625 9.121 32.6645 9.02562 32.7348 8.95529C32.8052 8.88497 32.9005 8.84546 33 8.84546H36C36.0995 8.84546 36.1948 8.88497 36.2652 8.95529C36.3355 9.02562 36.375 9.121 36.375 9.22046V21.2205C36.375 21.3199 36.3355 21.4153 36.2652 21.4856C36.1948 21.556 36.0995 21.5955 36 21.5955Z"
                                fill="var(--c-primary)"
                              />
                            </svg>
                          </span>

                          <span v-else-if="criteria.title === 'Water'">
                            <svg
                              width="48"
                              height="49"
                              viewBox="0 0 48 49"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M5 34.6805V32.6045C6.036 32.4765 6.84267 32.1365 7.42 31.5845C7.99867 31.0338 9.092 30.7585 10.7 30.7585C12.3853 30.7585 13.5747 31.0918 14.268 31.7585C14.9613 32.4251 15.9847 32.7585 17.338 32.7585C18.7073 32.7585 19.7387 32.4251 20.432 31.7585C21.1253 31.0918 22.3147 30.7585 24 30.7585C25.6693 30.7585 26.8587 31.0918 27.568 31.7585C28.2773 32.4251 29.3087 32.7585 30.662 32.7585C32.0313 32.7585 33.0587 32.4251 33.744 31.7585C34.4307 31.0918 35.616 30.7585 37.3 30.7585C38.908 30.7585 40.0013 31.0345 40.58 31.5865C41.1573 32.1371 41.964 32.4771 43 32.6065V34.6825C41.792 34.5278 40.8333 34.1685 40.124 33.6045C39.4147 33.0405 38.4733 32.7585 37.3 32.7585C35.972 32.7585 34.9547 33.0918 34.248 33.7585C33.5413 34.4251 32.346 34.7585 30.662 34.7585C28.9927 34.7585 27.8033 34.4251 27.094 33.7585C26.3847 33.0918 25.3533 32.7591 24 32.7605C22.6307 32.7605 21.5993 33.0938 20.906 33.7605C20.2127 34.4271 19.0233 34.7605 17.338 34.7605C15.6527 34.7605 14.4613 34.4271 13.764 33.7605C13.0667 33.0938 12.0453 32.7605 10.7 32.7605C9.484 32.7605 8.54867 33.0425 7.894 33.6065C7.23933 34.1718 6.27467 34.5311 5 34.6845M5 27.1445V25.0685C6.036 24.9405 6.84267 24.6005 7.42 24.0485C7.99867 23.4978 9.092 23.2225 10.7 23.2225C12.3693 23.2225 13.5547 23.5558 14.256 24.2225C14.9573 24.8891 15.9847 25.2225 17.338 25.2225C18.7073 25.2225 19.7387 24.8891 20.432 24.2225C21.1253 23.5558 22.3147 23.2218 24 23.2205C25.6693 23.2205 26.856 23.5538 27.56 24.2205C28.264 24.8871 29.2907 25.2205 30.64 25.2205C32.008 25.2205 33.0387 24.8871 33.732 24.2205C34.4253 23.5538 35.6147 23.2205 37.3 23.2205C38.892 23.2205 39.9853 23.4965 40.58 24.0485C41.1733 24.5991 41.98 24.9385 43 25.0665V27.1425C41.7773 26.9891 40.8153 26.6305 40.114 26.0665C39.4127 25.5025 38.4747 25.2205 37.3 25.2205C35.972 25.2205 34.9547 25.5538 34.248 26.2205C33.5413 26.8871 32.346 27.2205 30.662 27.2205C28.9927 27.2205 27.8033 26.8871 27.094 26.2205C26.386 25.5538 25.3547 25.2205 24 25.2205C22.6307 25.2205 21.6033 25.5538 20.918 26.2205C20.2313 26.8871 19.046 27.2205 17.362 27.2205C15.678 27.2205 14.478 26.8871 13.762 26.2205C13.046 25.5538 12.0253 25.2205 10.7 25.2205C9.5 25.2205 8.56467 25.5025 7.894 26.0665C7.22333 26.6305 6.25867 26.9898 5 27.1445ZM5 19.6045V17.5285C6.036 17.4005 6.84267 17.0605 7.42 16.5085C7.99867 15.9578 9.092 15.6825 10.7 15.6825C12.3693 15.6825 13.5547 16.0158 14.256 16.6825C14.9573 17.3491 15.9847 17.6825 17.338 17.6825C18.7073 17.6825 19.7387 17.3491 20.432 16.6825C21.1253 16.0158 22.3147 15.6818 24 15.6805C25.6693 15.6805 26.856 16.0138 27.56 16.6805C28.264 17.3471 29.2907 17.6805 30.64 17.6805C32.008 17.6805 33.0387 17.3471 33.732 16.6805C34.4253 16.0138 35.6147 15.6805 37.3 15.6805C38.892 15.6805 39.9853 15.9558 40.58 16.5065C41.1733 17.0585 41.98 17.3985 43 17.5265V19.6025C41.7773 19.4491 40.8153 19.0905 40.114 18.5265C39.4127 17.9625 38.4747 17.6805 37.3 17.6805C35.972 17.6805 34.9547 18.0138 34.248 18.6805C33.5413 19.3471 32.346 19.6805 30.662 19.6805C28.9927 19.6805 27.8033 19.3471 27.094 18.6805C26.386 18.0138 25.3547 17.6805 24 17.6805C22.6307 17.6805 21.6033 18.0138 20.918 18.6805C20.2313 19.3471 19.046 19.6805 17.362 19.6805C15.678 19.6805 14.478 19.3471 13.762 18.6805C13.046 18.0138 12.0253 17.6805 10.7 17.6805C9.5 17.6805 8.552 17.9625 7.856 18.5265C7.16 19.0905 6.208 19.4498 5 19.6045Z"
                                fill="var(--c-primary)"
                              />
                            </svg>
                          </span>
                          <span v-else>
                            <svg
                              width="48"
                              height="49"
                              viewBox="0 0 48 49"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <g clip-path="url(#clip0_481_37820)">
                                <path
                                  d="M44.9467 23.2738L24.9467 3.27383C24.6969 3.0255 24.359 2.88611 24.0067 2.88611C23.6545 2.88611 23.3165 3.0255 23.0667 3.27383L3.0667 23.2738C2.84827 23.5289 2.73413 23.857 2.74709 24.1926C2.76005 24.5281 2.89916 24.8465 3.13662 25.0839C3.37408 25.3214 3.6924 25.4605 4.02797 25.4734C4.36353 25.4864 4.69163 25.3723 4.9467 25.1538L24 6.1005L43.0534 25.1672C43.3084 25.3856 43.6365 25.4997 43.9721 25.4868C44.3077 25.4738 44.626 25.3347 44.8635 25.0972C45.1009 24.8598 45.24 24.5415 45.253 24.2059C45.2659 23.8703 45.1518 23.5422 44.9334 23.2872L44.9467 23.2738Z"
                                  fill="var(--c-primary)"
                                />
                                <path
                                  d="M37.3333 42.8872H30.6667V29.5538H17.3333V42.8872H10.6667V24.2205L8 26.8872V42.8872C8 43.5944 8.28095 44.2727 8.78105 44.7728C9.28115 45.2729 9.95942 45.5538 10.6667 45.5538H20V32.2205H28V45.5538H37.3333C38.0406 45.5538 38.7189 45.2729 39.219 44.7728C39.7191 44.2727 40 43.5944 40 42.8872V26.5672L37.3333 23.9005V42.8872Z"
                                  fill="var(--c-primary)"
                                />
                              </g>
                              <defs>
                                <clipPath id="clip0_481_37820">
                                  <rect width="48" height="48" fill="white" transform="translate(0 0.220459)" />
                                </clipPath>
                              </defs>
                            </svg>
                          </span>
                          <div>
                            <small class="n-title-primary tw-uppercase">{{ criteria.title }}</small>
                            <p>{{ criteria.value }}</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </template>

                  <!-- Floor Plan Slot -->
                  <template #floor_plan="{ item, isActive }">
                    <div class="tw-mt-8">
                      <floor-plan v-if="isActive" :data="property.floor_plans" :component="component" />
                    </div>
                  </template>

                  <!-- Map Slot -->
                  <template #map="{ item, isActive }">
                    <div class="tw-mt-8">
                      <neuron-google-map
                        v-if="
                          isActive && property.map_position && property.map_position.lat && property.map_position.lng
                        "
                        v-model:map-center-position="property.map_position"
                        :component="component"
                        :marker-color="markerColor"
                      />
                    </div>
                  </template>

                  <!-- EPC Slot -->
                  <template #epc="{ item, isActive }">
                    <div class="tw-mt-8">
                      <epc :data="property.epcs" id="epc" :component="component" />
                    </div>
                  </template>

                  <!-- Media Links Slot -->
                  <template #media_links="{ item, isActive }">
                    <div class="tw-flex tw-w-full tw-flex-col tw-gap-3">
                      <div
                        v-for="(m, i) in property.extra_medias"
                        :key="`extra-media-${i}`"
                        class="tw-flex tw-w-full tw-flex-col tw-items-start tw-justify-start tw-gap-3 tw-rounded tw-bg-[var(--c-section_primary)] tw-p-3 md:tw-flex-row md:tw-items-center md:tw-justify-between md:tw-gap-4"
                      >
                        <div class="tw-flex tw-min-w-0 tw-flex-1 tw-flex-col">
                          <small class="n-title-primary tw-uppercase">{{ m.name }}</small>
                          <p class="tw-break-words tw-text-sm tw-text-[var(--c-text_secondary)] md:tw-truncate">
                            {{ m.mediaLink }}
                          </p>
                        </div>
                        <nuxt-link
                          :href="m.mediaLink"
                          :external="true"
                          target="_blank"
                          rel="noopener"
                          class="n-primary tw-mt-1 tw-w-full tw-flex-shrink-0 tw-whitespace-nowrap tw-text-center md:tw-mt-0 md:tw-w-auto md:tw-text-left"
                        >
                          OPEN
                        </nuxt-link>
                      </div>
                    </div>
                  </template>
                </Theme7ComponentsAccordion>
              </div>
              <div
                v-if="isMortgageCalculatorVisible && property?.is_rent === false"
                class="mortgage tw-mt-12 lg:tw-mt-24"
                :class="property.is_rent ? 'rent-property' : 'sales-property'"
              >
                <library-tools-mortgage-calculator :default-price="property.price.numberPrice" />
              </div>

              <div
                v-if="isStampDutyCalculatorVisible && property?.is_rent === false"
                class="stamp tw-mt-12 lg:tw-mt-24"
                :class="property.is_rent ? 'rent-property' : 'sales-property'"
              >
                <library-tools-stamp-duty-calculator :default-price="property.price.numberPrice" />
              </div>
            </div>
            <div class="tw-col-span-12 tw-pt-6 lg:tw-col-span-5 xl:tw-col-span-4">
              <div v-if="sidebarComponents && sidebarComponents.length" class="tw-flex tw-flex-col tw-gap-4">
                <div v-if="vars.viewingOptionsBool">
                  <div
                    class="tw-relative tw-flex tw-w-full tw-flex-col tw-justify-center tw-gap-5 tw-px-4 tw-py-9 tw-text-start"
                    :style="`background-color: var(--c-sidebar-card); border-radius: var(--rounded);`"
                  >
                    <h4>{{ vars.viewingOptionsTitleText }}</h4>
                    <p v-if="vars.viewingOptionsDescriptionText">
                      {{ vars.viewingOptionsDescriptionText }}
                    </p>
                    <div class="tw-mt-2 tw-flex tw-flex-col tw-gap-4">
                      <button
                        v-if="featuredVideo"
                        :class="`n-${vars.viewingOptionsButton1TypeText} tw-w-fit`"
                        @click="onVidePopup()"
                      >
                        {{ vars.viewingOptionsButton1LabelText }}
                      </button>
                      <button :class="`n-${vars.viewingOptionsButton2TypeText} tw-w-fit`" @click="onSendLead()">
                        {{ vars.viewingOptionsButton2LabelText }}
                      </button>
                    </div>
                  </div>
                </div>
                <theme7-available-components-for-sidebar
                  key="property-detail-sidebar"
                  key-prefix="property-detail-sidebar"
                  :specific-components="sidebarComponents"
                />
              </div>
            </div>
          </div>
        </div>

        <full-screen-gallery
          v-if="fullScreenPopupConfig.is_active && activeMedia && property && property.medias"
          v-model:active-media-index="activeMediaIndex"
          :component="component"
          :active-media="activeMedia"
          :count-of-medias="property.medias.length"
          @close="(closeLightbox(), toggleHeader())"
        />

        <popup :config="sendLeadPopupConfig" custom-width="800px">
          <template #content>
            <send-lead
              v-if="sendLeadPopupConfig.isActive"
              :property="property"
              @on-success="onSuccess"
              @close="sendLeadPopupConfig.isActive = false"
            />
          </template>
        </popup>

        <popup :config="videoPopupConfig" v-if="videoPopupConfig.videoPopupSrc" custom-width="500px" @close="stopVideo">
          <template #content>
            <div class="tw-relative tw-pt-6">
              <div class="tw-aspect-[9/16] tw-h-full tw-w-full">
                <library-iframe
                  class="tw-absolute tw-inset-0 tw-h-full tw-w-full"
                  :src="videoPopupConfig.videoPopupSrc"
                  frameborder="0"
                  allowfullscreen
                  :blur="imageBlurFilter"
                  :pre-market-blur-text="preMarketBlurText"
                ></library-iframe>
              </div>
            </div>
          </template>
        </popup>

        <popup :config="successModalConfig" @close="onSuccessModalClosed()">
          <template #content>
            <success :text="successPopupText" />
          </template>
        </popup>
      </section>
    </template>
    <template v-else-if="property?.is_locked">
      <section class="!tw-pt-0" style="background-color: var(--c-section_primary)">
        <div class="container">
          <library-login />
        </div>
      </section>
    </template>
  </div>

  <div
    class="property-detail layout-pb-lg"
    v-if="variants.v4 === variant"
    :style="`background-color: var(--c-${vars.backgroundColor});`"
  >
    <section class="relative !tw-block !tw-pt-44 tw-pb-6 lg:tw-pb-12">
      <div v-if="vars.galleryVersionText === 'v2'" class="container">
        <library-properties-back-to-all-properties-navbar
          class="tw-mb-10"
          text="BACK TO ALL PROPERTIES"
          color="var(--c-primary)"
        />
      </div>
      <template v-if="vars.galleryVersionText === 'v2'">
        <div data-anim="slide-up delay-1" class="tabs__content js-tabs-content">
          <div class="tabs__pane -tab-item-1 is-tab-el-active">
            <div class="container">
              <div class="row justify-center">
                <div class="col-12">
                  <div
                    class="relative js-section-slider"
                    data-anim="slide-left delay-1"
                    data-gap="20"
                    data-slider-cols="xl-2.25 lg-2.25 md-1.25 sm-1 base-1"
                  >
                    <div class="swiper-wrapper">
                      <div
                        v-for="(image, index) in allPhotos"
                        :key="`property-detail-image-${index}`"
                        class="swiper-slide relative"
                      >
                        <div class="ratio ratio-16:9 !tw-z-0">
                          <library-image
                            :src="image.background"
                            alt="image"
                            image-class="img-ratio !tw-z-0 tw-cursor-grab"
                            @click="(onClickedImage(image), toggleHeader())"
                            :blur="imageBlurFilter"
                            :pre-market-blur-text="preMarketBlurText"
                          />
                          <div v-if="property && property.medias && index === 0" class="nc-first-image-overlay-item">
                            <div
                              style="
                                border-radius: var(--rounded-sm);
                                color: var(--c-primary);
                                background-color: var(--c-section_primary);
                              "
                              @click="(onClickedImage(image), toggleHeader())"
                              class="tw-text-md tw-px-2 tw-py-1"
                            >
                              {{ index + 1 }}/{{ property.medias.length }}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="d-flex mt-60 md:mt-30 max-lg:tw-items-center max-lg:tw-justify-center">
                      <button class="sliderNav -prev js-prev n-link" @click="slidePrev">
                        <i class="icon-left-arrow"></i>
                      </button>
                      <button class="sliderNav -next ml-20 js-next n-link" @click="slideNext">
                        <i class="icon-right-arrow"></i>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
      <template v-else>
        <div data-anim="slide-up delay-1" class="tabs__content pt-60 md:pt-30 js-tabs-content">
          <div class="tabs__pane -tab-item-1 is-tab-el-active">
            <div class="row justify-center">
              <div class="col-xl-5 col-lg-6 col-md-9">
                <div class="relative js-section-slider" data-slider-cols="xl-1 lg-1 md-1 sm-1 base-1" data-loop>
                  <div class="swiper-wrapper h-auto items-center-imp -image-slider-1">
                    <div v-for="(image, index) in maxPhotosToShow" class="swiper-slide relative">
                      <div class="ratio ratio-16:9 !tw-z-0">
                        <library-image
                          :src="image.background"
                          alt="image"
                          image-class="img-ratio !tw-z-0 tw-cursor-grab"
                          @click="(onClickedImage(image), toggleHeader())"
                          :blur="imageBlurFilter"
                          :pre-market-blur-text="preMarketBlurText"
                        />
                        <div v-if="property && property.medias" class="nc-first-image-overlay-item">
                          <div
                            style="
                              border-radius: var(--rounded-sm);
                              color: var(--c-primary);
                              background-color: var(--c-section_primary);
                            "
                            @click="(onClickedImage(image), toggleHeader())"
                            class="tw-text-md tw-px-2 tw-py-1"
                          >
                            {{ index + 1 }}/{{ property.medias.length }}
                          </div>
                        </div>
                      </div>
                      <div class="exploreButton !tw-z-50 tw-cursor-grab">
                        <button
                          style="color: var(--c-primary)"
                          class="button bg-dark-1 fw-500 rounded-full tw-h-14 tw-w-14 !tw-rounded-full !tw-bg-white !tw-p-6 md:tw-h-16 md:tw-w-16 lg:tw-h-20 lg:tw-w-20"
                        >
                          SWIPE
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
    </section>
    <!-- GALLERY: END -->
    <section
      v-if="property"
      class="tw-pb-6 lg:tw-pb-12"
      :style="{
        backgroundColor: vars.backgroundColor ? `var(--c-${vars.backgroundColor})` : 'var(--c-section_secondary)',
      }"
    >
      <div class="container">
        <div class="property-detail-info tw-flex tw-w-full tw-flex-col tw-py-12">
          <div class="tw-grid tw-grid-cols-12 tw-items-start tw-justify-between">
            <div class="tw-col-span-12 tw-flex tw-flex-col lg:tw-col-span-7">
              <h3>{{ property.advert_heading }}</h3>
              <div class="address tw-mt-5 tw-flex tw-items-center tw-gap-1">
                <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M11.5 12.5C10.8078 12.5 10.1311 12.2947 9.55551 11.9101C8.97993 11.5256 8.53133 10.9789 8.26642 10.3394C8.00152 9.69985 7.9322 8.99612 8.06725 8.31719C8.2023 7.63825 8.53564 7.01461 9.02513 6.52513C9.51461 6.03564 10.1383 5.7023 10.8172 5.56725C11.4961 5.4322 12.1999 5.50152 12.8394 5.76642C13.4789 6.03133 14.0256 6.47993 14.4101 7.05551C14.7947 7.63108 15 8.30777 15 9C14.9989 9.92792 14.6298 10.8175 13.9736 11.4736C13.3175 12.1298 12.4279 12.4989 11.5 12.5ZM11.5 6.9C11.0847 6.9 10.6786 7.02316 10.3333 7.25392C9.98796 7.48467 9.7188 7.81264 9.55985 8.19637C9.40091 8.58009 9.35932 9.00233 9.44035 9.40969C9.52138 9.81705 9.72139 10.1912 10.0151 10.4849C10.3088 10.7786 10.683 10.9786 11.0903 11.0596C11.4977 11.1407 11.9199 11.0991 12.3036 10.9401C12.6874 10.7812 13.0153 10.512 13.2461 10.1667C13.4768 9.82136 13.6 9.41534 13.6 9C13.5994 8.44322 13.378 7.9094 12.9843 7.51569C12.5906 7.12199 12.0568 6.90056 11.5 6.9Z"
                    :fill="property.is_rent ? 'var(--c-tertiary)' : 'var(--c-primary)'"
                  />
                  <path
                    d="M11.5 21.5L5.74819 14.3936C5.66826 14.2869 5.58917 14.1795 5.51091 14.0714C4.5289 12.7153 3.99818 11.0594 4 9.35714C4 7.2733 4.79018 5.2748 6.1967 3.8013C7.60322 2.3278 9.51088 1.5 11.5 1.5C13.4891 1.5 15.3968 2.3278 16.8033 3.8013C18.2098 5.2748 19 7.2733 19 9.35714C19.0016 11.0585 18.4711 12.7136 17.4898 14.0693L17.4891 14.0714C17.4891 14.0714 17.2845 14.3529 17.2539 14.3907L11.5 21.5ZM6.59978 13.2107C6.59978 13.2107 6.75864 13.4307 6.79478 13.4779L11.5 19.2914L16.2114 13.47C16.2414 13.4307 16.4009 13.2093 16.4016 13.2086C17.2042 12.1008 17.638 10.7479 17.6364 9.35714C17.6364 7.65218 16.9899 6.01705 15.8391 4.81146C14.6883 3.60587 13.1275 2.92857 11.5 2.92857C9.87254 2.92857 8.31173 3.60587 7.16094 4.81146C6.01015 6.01705 5.36364 7.65218 5.36364 9.35714C5.36196 10.7488 5.79622 12.1026 6.59978 13.2107Z"
                    :fill="property.is_rent ? 'var(--c-tertiary)' : 'var(--c-primary)'"
                  />
                </svg>

                <p class="tw-capitalize">{{ property.display_address }}</p>
              </div>
              <div v-if="!property?.is_locked" class="tw-mt-5 tw-flex tw-items-center tw-gap-1">
                <div class="rooms tw-flex tw-flex-row tw-items-center tw-gap-4">
                  <div class="tw-flex tw-items-center tw-gap-2">
                    <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M3 18.5V11.5H4V7.5H20V11.5H21V18.5H20V16.5H4V18.5H3ZM12.5 11.5H19V8.5H12.5V11.5ZM5 11.5H11.5V8.5H5V11.5ZM4 15.5H20V12.5H4V15.5Z"
                        :fill="property.is_rent ? 'var(--c-tertiary)' : 'var(--c-primary)'"
                      />
                    </svg>
                    <p>{{ property.bedroom }} Beds</p>
                  </div>

                  <div class="tw-flex tw-items-center tw-gap-2">
                    <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M3 12.1552H22M8.7 19.0517H16.3M8.7 19.0517C7.69218 19.0517 6.72563 18.6158 6.01299 17.8398C5.30036 17.0637 4.9 16.0112 4.9 14.9138V6.63793C4.9 5.54048 5.30036 4.48798 6.01299 3.71197C6.72563 2.93596 7.69218 2.5 8.7 2.5H11.2333V4.56897M8.7 19.0517V22.5M16.3 19.0517C17.3078 19.0517 18.2744 18.6158 18.987 17.8398C19.6996 17.0637 20.1 16.0112 20.1 14.9138V12.1552M16.3 19.0517V22.5M9.33333 6.63793H13.1333"
                        :stroke="property.is_rent ? 'var(--c-tertiary)' : 'var(--c-primary)'"
                      />
                    </svg>

                    <p>{{ property.bathroom }} Baths</p>
                  </div>

                  <div class="tw-flex tw-items-center tw-gap-2">
                    <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M3 16.4001V19.1001M4.8 10.1001V8.30006C4.8 7.82267 4.98964 7.36483 5.32721 7.02727C5.66477 6.6897 6.12261 6.50006 6.6 6.50006H17.4C17.8774 6.50006 18.3352 6.6897 18.6728 7.02727C19.0104 7.36483 19.2 7.82267 19.2 8.30006V10.1001"
                        :stroke="property.is_rent ? 'var(--c-tertiary)' : 'var(--c-primary)'"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M21 16.4001V19.1001M19.2 10.1001C18.7226 10.1001 18.2648 10.2897 17.9272 10.6273C17.5896 10.9649 17.4 11.4227 17.4 11.9001V13.7001H6.6V11.9001C6.6 11.4227 6.41036 10.9649 6.07279 10.6273C5.73523 10.2897 5.27739 10.1001 4.8 10.1001C4.32261 10.1001 3.86477 10.2897 3.52721 10.6273C3.18964 10.9649 3 11.4227 3 11.9001V17.3001H21V11.9001C21 11.4227 20.8104 10.9649 20.4728 10.6273C20.1352 10.2897 19.6774 10.1001 19.2 10.1001Z"
                        :stroke="property.is_rent ? 'var(--c-tertiary)' : 'var(--c-primary)'"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>

                    <p>{{ property.reception }} Reception</p>
                  </div>
                </div>
              </div>
            </div>
            <div
              class="tw-col-span-12 tw-flex tw-flex-col tw-justify-between lg:tw-col-span-5 lg:tw-items-end lg:tw-justify-end lg:tw-gap-8"
            >
              <div
                class="tw-mt-5 tw-flex tw-w-full tw-items-center tw-justify-between max-lg:tw-pt-4 lg:tw-justify-end lg:tw-gap-8"
              >
                <div v-if="property.price" class="tw-flex tw-flex-col lg:tw-items-end">
                  <h4 v-if="property.price.type.name" class="tw-mb-4 tw-uppercase">
                    {{ property.price.type.name }}
                  </h4>
                  <h2 :style="{ color: property.is_rent ? 'var(--c-tertiary)' : '#fff' }">
                    {{ property.price.price }}
                  </h2>
                </div>
              </div>
              <button
                v-if="!property?.is_locked"
                :class="property.is_rent ? 'n-tertiary' : 'n-primary'"
                class="tw-mt-12 tw-w-full tw-self-start md:tw-w-auto lg:tw-mt-6 lg:tw-self-end"
                @click="onSendLead()"
              >
                BOOK A VIEWING
              </button>
            </div>
          </div>
        </div>
        <div v-if="featuredVideo && matterPort" class="tw-mt-8 tw-flex tw-flex-col tw-gap-6 lg:tw-flex-row">
          <div class="tw-aspect-video tw-w-full lg:tw-w-1/2">
            <library-iframe
              class="tw-inset-0"
              :src="featuredVideo"
              frameborder="0"
              allowfullscreen
              :blur="imageBlurFilter"
              :pre-market-blur-text="preMarketBlurText"
            ></library-iframe>
          </div>
          <div class="tw-aspect-video tw-w-full lg:tw-w-1/2">
            <library-iframe
              class="tw-inset-0"
              :src="matterPort"
              frameborder="0"
              allowfullscreen
              :blur="imageBlurFilter"
              :pre-market-blur-text="preMarketBlurText"
            ></library-iframe>
          </div>
        </div>
      </div>
    </section>

    <!-- PROPERTY DETAIL -->
    <template v-if="!property?.is_locked">
      <section class="!tw-pt-0" style="background-color: var(--c-section_primary)">
        <div class="container">
          <div class="tw-grid tw-grid-cols-12 md:tw-gap-x-10">
            <div class="tw-col-span-12 tw-flex tw-flex-col tw-gap-y-12 lg:tw-col-span-7 xl:tw-col-span-8">
              <div v-if="featuredVideo && !matterPort" class="tw-mt-8 tw-flex tw-flex-col tw-gap-6 lg:tw-flex-row">
                <div class="tw-aspect-video tw-w-full">
                  <library-iframe
                    class="tw-inset-0"
                    :src="featuredVideo"
                    frameborder="0"
                    allowfullscreen
                    :blur="imageBlurFilter"
                    :pre-market-blur-text="preMarketBlurText"
                  ></library-iframe>
                </div>
              </div>
              <div v-if="!featuredVideo && matterPort" class="tw-mt-8 tw-flex tw-flex-col tw-gap-6 lg:tw-flex-row">
                <div class="tw-aspect-video tw-w-full">
                  <library-iframe
                    class="tw-inset-0"
                    :src="matterPort"
                    frameborder="0"
                    allowfullscreen
                    :blur="imageBlurFilter"
                    :pre-market-blur-text="preMarketBlurText"
                  ></library-iframe>
                </div>
              </div>

              <div class="tw-my-6 tw-w-full">
                <Theme7ComponentsAccordion
                  class="tw-w-full"
                  :items="propertyAccordionItems"
                  :allow-multiple="false"
                  :show-numbers="false"
                  @accordion-toggle="onAccordionToggle"
                >
                  <!-- Features Slot -->
                  <template #features="{ item, isActive }">
                    <div v-if="property?.features" class="tw-mt-8 tw-grid tw-grid-cols-12 tw-gap-4">
                      <div
                        v-for="(feature, index) in property.features"
                        :key="`property-feature-${index}`"
                        class="tw-col-span-12 tw-flex tw-items-start tw-gap-x-3 md:tw-col-span-6 xl:tw-col-span-4"
                      >
                        <span>
                          <svg
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M9.5501 18L3.8501 12.3L5.2751 10.875L9.5501 15.15L18.7251 5.97498L20.1501 7.39998L9.5501 18Z"
                              fill="var(--c-primary)"
                            />
                          </svg>
                        </span>
                        <library-text class="tw-text-sm tw-font-semibold tw-uppercase" :text="feature"></library-text>
                      </div>
                    </div>
                  </template>

                  <!-- Property Information Slot -->
                  <template #property_information="{ item, isActive }">
                    <div class="tw-mt-8">
                      <!-- amenties -->
                      <div
                        class="tw-mt-4 tw-flex tw-flex-col tw-gap-4 md:tw-mt-8 md:tw-flex-row md:tw-flex-wrap md:tw-gap-6"
                      >
                        <div
                          v-for="criteria in property.criteria_list"
                          :key="criteria.id"
                          class="tw-flex tw-gap-4 tw-p-4"
                          style="background-color: var(--c-section_primary); border-radius: var(--rounded)"
                        >
                          <span v-if="criteria.title === 'Parking'">
                            <svg
                              width="48"
                              height="49"
                              viewBox="0 0 48 49"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M45 21.5955H42.7312L37.4231 9.65358C37.2168 9.18982 36.8805 8.79581 36.4549 8.51927C36.0293 8.24273 35.5326 8.09552 35.025 8.09546H12.975C12.4674 8.09552 11.9707 8.24273 11.5451 8.51927C11.1195 8.79581 10.7832 9.18982 10.5769 9.65358L5.26875 21.5955H3C2.70163 21.5955 2.41548 21.714 2.2045 21.925C1.99353 22.1359 1.875 22.4221 1.875 22.7205C1.875 23.0188 1.99353 23.305 2.2045 23.516C2.41548 23.7269 2.70163 23.8455 3 23.8455H4.875V39.2205C4.875 39.9167 5.15156 40.5843 5.64384 41.0766C6.13613 41.5689 6.80381 41.8455 7.5 41.8455H12C12.6962 41.8455 13.3639 41.5689 13.8562 41.0766C14.3484 40.5843 14.625 39.9167 14.625 39.2205V35.8455H33.375V39.2205C33.375 39.9167 33.6516 40.5843 34.1438 41.0766C34.6361 41.5689 35.3038 41.8455 36 41.8455H40.5C41.1962 41.8455 41.8639 41.5689 42.3562 41.0766C42.8484 40.5843 43.125 39.9167 43.125 39.2205V23.8455H45C45.2984 23.8455 45.5845 23.7269 45.7955 23.516C46.0065 23.305 46.125 23.0188 46.125 22.7205C46.125 22.4221 46.0065 22.1359 45.7955 21.925C45.5845 21.714 45.2984 21.5955 45 21.5955ZM12.6319 10.5686C12.6613 10.5021 12.7094 10.4457 12.7703 10.4061C12.8312 10.3665 12.9023 10.3454 12.975 10.3455H35.025C35.0977 10.3454 35.1688 10.3665 35.2297 10.4061C35.2906 10.4457 35.3387 10.5021 35.3681 10.5686L40.2694 21.5955H7.73063L12.6319 10.5686ZM12.375 39.2205C12.375 39.3199 12.3355 39.4153 12.2652 39.4856C12.1948 39.556 12.0995 39.5955 12 39.5955H7.5C7.40054 39.5955 7.30516 39.556 7.23483 39.4856C7.16451 39.4153 7.125 39.3199 7.125 39.2205V35.8455H12.375V39.2205ZM40.5 39.5955H36C35.9005 39.5955 35.8052 39.556 35.7348 39.4856C35.6645 39.4153 35.625 39.3199 35.625 39.2205V35.8455H40.875V39.2205C40.875 39.3199 40.8355 39.4153 40.7652 39.4856C40.6948 39.556 40.5995 39.5955 40.5 39.5955ZM40.875 33.5955H7.125V23.8455H40.875V33.5955ZM10.875 28.7205C10.875 28.4221 10.9935 28.1359 11.2045 27.925C11.4155 27.714 11.7016 27.5955 12 27.5955H15C15.2984 27.5955 15.5845 27.714 15.7955 27.925C16.0065 28.1359 16.125 28.4221 16.125 28.7205C16.125 29.0188 16.0065 29.305 15.7955 29.516C15.5845 29.7269 15.2984 29.8455 15 29.8455H12C11.7016 29.8455 11.4155 29.7269 11.2045 29.516C10.9935 29.305 10.875 29.0188 10.875 28.7205ZM31.875 28.7205C31.875 28.4221 31.9935 28.1359 32.2045 27.925C32.4155 27.714 32.7016 27.5955 33 27.5955H36C36.2984 27.5955 36.5845 27.714 36.7955 27.925C37.0065 28.1359 37.125 28.4221 37.125 28.7205C37.125 29.0188 37.0065 29.305 36.7955 29.516C36.5845 29.7269 36.2984 29.8455 36 29.8455H33C32.7016 29.8455 32.4155 29.7269 32.2045 29.516C31.9935 29.305 31.875 29.0188 31.875 28.7205Z"
                                fill="var(--c-primary)"
                              />
                            </svg>
                          </span>

                          <span v-else-if="criteria.title === 'Sewerage'">
                            <svg
                              width="48"
                              height="49"
                              viewBox="0 0 48 49"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M43.5 20.0955H38.625V10.3455H43.5C43.7984 10.3455 44.0845 10.2269 44.2955 10.016C44.5065 9.80498 44.625 9.51883 44.625 9.22046C44.625 8.92209 44.5065 8.63594 44.2955 8.42496C44.0845 8.21399 43.7984 8.09546 43.5 8.09546H38.3681C38.1555 7.6472 37.8202 7.26837 37.4011 7.00289C36.9819 6.7374 36.4961 6.59614 36 6.59546H33C32.5039 6.59614 32.0181 6.7374 31.5989 7.00289C31.1798 7.26837 30.8445 7.6472 30.6319 8.09546H27C21.9296 8.10141 17.0685 10.1183 13.4832 13.7036C9.89782 17.289 7.88095 22.15 7.875 27.2205V30.8523C7.42674 31.065 7.04791 31.4003 6.78243 31.8194C6.51694 32.2385 6.37568 32.7243 6.375 33.2205V36.2205C6.37568 36.7166 6.51694 37.2024 6.78243 37.6215C7.04791 38.0406 7.42674 38.376 7.875 38.5886V43.7205C7.875 44.0188 7.99353 44.305 8.2045 44.516C8.41548 44.7269 8.70163 44.8455 9 44.8455C9.29837 44.8455 9.58452 44.7269 9.7955 44.516C10.0065 44.305 10.125 44.0188 10.125 43.7205V38.8455H19.875V43.7205C19.875 44.0188 19.9935 44.305 20.2045 44.516C20.4155 44.7269 20.7016 44.8455 21 44.8455C21.2984 44.8455 21.5845 44.7269 21.7955 44.516C22.0065 44.305 22.125 44.0188 22.125 43.7205V38.5886C22.5733 38.376 22.9521 38.0406 23.2176 37.6215C23.4831 37.2024 23.6243 36.7166 23.625 36.2205V33.2205C23.6243 32.7243 23.4831 32.2385 23.2176 31.8194C22.9521 31.4003 22.5733 31.065 22.125 30.8523V27.2205C22.125 25.9275 22.6386 24.6876 23.5529 23.7733C24.4671 22.8591 25.7071 22.3455 27 22.3455H30.6319C30.8445 22.7937 31.1798 23.1726 31.5989 23.438C32.0181 23.7035 32.5039 23.8448 33 23.8455H36C36.4961 23.8448 36.9819 23.7035 37.4011 23.438C37.8202 23.1726 38.1555 22.7937 38.3681 22.3455H43.5C43.7984 22.3455 44.0845 22.2269 44.2955 22.016C44.5065 21.805 44.625 21.5188 44.625 21.2205C44.625 20.9221 44.5065 20.6359 44.2955 20.425C44.0845 20.214 43.7984 20.0955 43.5 20.0955ZM21 32.8455C21.0995 32.8455 21.1948 32.885 21.2652 32.9553C21.3355 33.0256 21.375 33.121 21.375 33.2205V36.2205C21.375 36.3199 21.3355 36.4153 21.2652 36.4856C21.1948 36.556 21.0995 36.5955 21 36.5955H9C8.90054 36.5955 8.80516 36.556 8.73483 36.4856C8.66451 36.4153 8.625 36.3199 8.625 36.2205V33.2205C8.625 33.121 8.66451 33.0256 8.73483 32.9553C8.80516 32.885 8.90054 32.8455 9 32.8455H21ZM19.875 27.2205V30.5955H10.125V27.2205C10.13 22.7465 11.9095 18.4571 15.0731 15.2935C18.2367 12.1299 22.526 10.3504 27 10.3455H30.375V20.0955H27C25.1103 20.0955 23.2981 20.8461 21.9619 22.1823C20.6257 23.5185 19.875 25.3308 19.875 27.2205ZM36 21.5955H33C32.9005 21.5955 32.8052 21.556 32.7348 21.4856C32.6645 21.4153 32.625 21.3199 32.625 21.2205V9.22046C32.625 9.121 32.6645 9.02562 32.7348 8.95529C32.8052 8.88497 32.9005 8.84546 33 8.84546H36C36.0995 8.84546 36.1948 8.88497 36.2652 8.95529C36.3355 9.02562 36.375 9.121 36.375 9.22046V21.2205C36.375 21.3199 36.3355 21.4153 36.2652 21.4856C36.1948 21.556 36.0995 21.5955 36 21.5955Z"
                                fill="var(--c-primary)"
                              />
                            </svg>
                          </span>

                          <span v-else-if="criteria.title === 'Water'">
                            <svg
                              width="48"
                              height="49"
                              viewBox="0 0 48 49"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M5 34.6805V32.6045C6.036 32.4765 6.84267 32.1365 7.42 31.5845C7.99867 31.0338 9.092 30.7585 10.7 30.7585C12.3853 30.7585 13.5747 31.0918 14.268 31.7585C14.9613 32.4251 15.9847 32.7585 17.338 32.7585C18.7073 32.7585 19.7387 32.4251 20.432 31.7585C21.1253 31.0918 22.3147 30.7585 24 30.7585C25.6693 30.7585 26.8587 31.0918 27.568 31.7585C28.2773 32.4251 29.3087 32.7585 30.662 32.7585C32.0313 32.7585 33.0587 32.4251 33.744 31.7585C34.4307 31.0918 35.616 30.7585 37.3 30.7585C38.908 30.7585 40.0013 31.0345 40.58 31.5865C41.1573 32.1371 41.964 32.4771 43 32.6065V34.6825C41.792 34.5278 40.8333 34.1685 40.124 33.6045C39.4147 33.0405 38.4733 32.7585 37.3 32.7585C35.972 32.7585 34.9547 33.0918 34.248 33.7585C33.5413 34.4251 32.346 34.7585 30.662 34.7585C28.9927 34.7585 27.8033 34.4251 27.094 33.7585C26.3847 33.0918 25.3533 32.7591 24 32.7605C22.6307 32.7605 21.5993 33.0938 20.906 33.7605C20.2127 34.4271 19.0233 34.7605 17.338 34.7605C15.6527 34.7605 14.4613 34.4271 13.764 33.7605C13.0667 33.0938 12.0453 32.7605 10.7 32.7605C9.484 32.7605 8.54867 33.0425 7.894 33.6065C7.23933 34.1718 6.27467 34.5311 5 34.6845M5 27.1445V25.0685C6.036 24.9405 6.84267 24.6005 7.42 24.0485C7.99867 23.4978 9.092 23.2225 10.7 23.2225C12.3693 23.2225 13.5547 23.5558 14.256 24.2225C14.9573 24.8891 15.9847 25.2225 17.338 25.2225C18.7073 25.2225 19.7387 24.8891 20.432 24.2225C21.1253 23.5558 22.3147 23.2218 24 23.2205C25.6693 23.2205 26.856 23.5538 27.56 24.2205C28.264 24.8871 29.2907 25.2205 30.64 25.2205C32.008 25.2205 33.0387 24.8871 33.732 24.2205C34.4253 23.5538 35.6147 23.2205 37.3 23.2205C38.892 23.2205 39.9853 23.4965 40.58 24.0485C41.1733 24.5991 41.98 24.9385 43 25.0665V27.1425C41.7773 26.9891 40.8153 26.6305 40.114 26.0665C39.4127 25.5025 38.4747 25.2205 37.3 25.2205C35.972 25.2205 34.9547 25.5538 34.248 26.2205C33.5413 26.8871 32.346 27.2205 30.662 27.2205C28.9927 27.2205 27.8033 26.8871 27.094 26.2205C26.386 25.5538 25.3547 25.2205 24 25.2205C22.6307 25.2205 21.6033 25.5538 20.918 26.2205C20.2313 26.8871 19.046 27.2205 17.362 27.2205C15.678 27.2205 14.478 26.8871 13.762 26.2205C13.046 25.5538 12.0253 25.2205 10.7 25.2205C9.5 25.2205 8.56467 25.5025 7.894 26.0665C7.22333 26.6305 6.25867 26.9898 5 27.1445ZM5 19.6045V17.5285C6.036 17.4005 6.84267 17.0605 7.42 16.5085C7.99867 15.9578 9.092 15.6825 10.7 15.6825C12.3693 15.6825 13.5547 16.0158 14.256 16.6825C14.9573 17.3491 15.9847 17.6825 17.338 17.6825C18.7073 17.6825 19.7387 17.3491 20.432 16.6825C21.1253 16.0158 22.3147 15.6818 24 15.6805C25.6693 15.6805 26.856 16.0138 27.56 16.6805C28.264 17.3471 29.2907 17.6805 30.64 17.6805C32.008 17.6805 33.0387 17.3471 33.732 16.6805C34.4253 16.0138 35.6147 15.6805 37.3 15.6805C38.892 15.6805 39.9853 15.9558 40.58 16.5065C41.1733 17.0585 41.98 17.3985 43 17.5265V19.6025C41.7773 19.4491 40.8153 19.0905 40.114 18.5265C39.4127 17.9625 38.4747 17.6805 37.3 17.6805C35.972 17.6805 34.9547 18.0138 34.248 18.6805C33.5413 19.3471 32.346 19.6805 30.662 19.6805C28.9927 19.6805 27.8033 19.3471 27.094 18.6805C26.386 18.0138 25.3547 17.6805 24 17.6805C22.6307 17.6805 21.6033 18.0138 20.918 18.6805C20.2313 19.3471 19.046 19.6805 17.362 19.6805C15.678 19.6805 14.478 19.3471 13.762 18.6805C13.046 18.0138 12.0253 17.6805 10.7 17.6805C9.5 17.6805 8.552 17.9625 7.856 18.5265C7.16 19.0905 6.208 19.4498 5 19.6045Z"
                                fill="var(--c-primary)"
                              />
                            </svg>
                          </span>
                          <span v-else>
                            <svg
                              width="48"
                              height="49"
                              viewBox="0 0 48 49"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <g clip-path="url(#clip0_481_37820)">
                                <path
                                  d="M44.9467 23.2738L24.9467 3.27383C24.6969 3.0255 24.359 2.88611 24.0067 2.88611C23.6545 2.88611 23.3165 3.0255 23.0667 3.27383L3.0667 23.2738C2.84827 23.5289 2.73413 23.857 2.74709 24.1926C2.76005 24.5281 2.89916 24.8465 3.13662 25.0839C3.37408 25.3214 3.6924 25.4605 4.02797 25.4734C4.36353 25.4864 4.69163 25.3723 4.9467 25.1538L24 6.1005L43.0534 25.1672C43.3084 25.3856 43.6365 25.4997 43.9721 25.4868C44.3077 25.4738 44.626 25.3347 44.8635 25.0972C45.1009 24.8598 45.24 24.5415 45.253 24.2059C45.2659 23.8703 45.1518 23.5422 44.9334 23.2872L44.9467 23.2738Z"
                                  fill="var(--c-primary)"
                                />
                                <path
                                  d="M37.3333 42.8872H30.6667V29.5538H17.3333V42.8872H10.6667V24.2205L8 26.8872V42.8872C8 43.5944 8.28095 44.2727 8.78105 44.7728C9.28115 45.2729 9.95942 45.5538 10.6667 45.5538H20V32.2205H28V45.5538H37.3333C38.0406 45.5538 38.7189 45.2729 39.219 44.7728C39.7191 44.2727 40 43.5944 40 42.8872V26.5672L37.3333 23.9005V42.8872Z"
                                  fill="var(--c-primary)"
                                />
                              </g>
                              <defs>
                                <clipPath id="clip0_481_37820">
                                  <rect width="48" height="48" fill="white" transform="translate(0 0.220459)" />
                                </clipPath>
                              </defs>
                            </svg>
                          </span>
                          <div>
                            <small class="n-title-primary tw-uppercase">{{ criteria.title }}</small>
                            <p>{{ criteria.value }}</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </template>

                  <!-- Floor Plan Slot -->
                  <template #floor_plan="{ item, isActive }">
                    <div class="tw-mt-8">
                      <floor-plan :data="property.floor_plans" :component="component" />
                    </div>
                  </template>

                  <!-- Map Slot -->
                  <template #map="{ item, isActive }">
                    <div class="tw-mt-8">
                      <neuron-google-map
                        v-if="property.map_position && property.map_position.lat && property.map_position.lng"
                        v-model:map-center-position="property.map_position"
                        :component="component"
                        :marker-color="markerColor"
                      />
                    </div>
                  </template>

                  <!-- EPC Slot -->
                  <template #epc="{ item, isActive }">
                    <div class="tw-mt-8">
                      <epc :data="property.epcs" id="epc" :component="component" />
                    </div>
                  </template>
                </Theme7ComponentsAccordion>
              </div>
              <div
                v-if="isMortgageCalculatorVisible && property?.is_rent === false"
                class="mortgage tw-mt-12 lg:tw-mt-24"
                :class="property.is_rent ? 'rent-property' : 'sales-property'"
              >
                <library-tools-mortgage-calculator :default-price="property.price.numberPrice" />
              </div>

              <div
                v-if="isStampDutyCalculatorVisible && property?.is_rent === false"
                class="stamp tw-mt-12 lg:tw-mt-24"
                :class="property.is_rent ? 'rent-property' : 'sales-property'"
              >
                <library-tools-stamp-duty-calculator :default-price="property.price.numberPrice" />
              </div>
            </div>
            <div class="tw-col-span-12 tw-pt-6 lg:tw-col-span-5 xl:tw-col-span-4">
              <div v-if="sidebarComponents && sidebarComponents.length" class="tw-flex tw-flex-col tw-gap-4">
                <div v-if="vars.viewingOptionsBool">
                  <div
                    class="tw-relative tw-flex tw-w-full tw-flex-col tw-justify-center tw-gap-5 tw-px-4 tw-py-9 tw-text-start"
                    :style="`background-color: var(--c-sidebar-card); border-radius: var(--rounded);`"
                  >
                    <h4>{{ vars.viewingOptionsTitleText }}</h4>
                    <p v-if="vars.viewingOptionsDescriptionText">
                      {{ vars.viewingOptionsDescriptionText }}
                    </p>
                    <div class="tw-mt-2 tw-flex tw-flex-col tw-gap-4">
                      <button
                        v-if="featuredVideo"
                        :class="`n-${vars.viewingOptionsButton1TypeText} tw-w-fit`"
                        @click="onVidePopup()"
                      >
                        {{ vars.viewingOptionsButton1LabelText }}
                      </button>
                      <button :class="`n-${vars.viewingOptionsButton2TypeText} tw-w-fit`" @click="onSendLead()">
                        {{ vars.viewingOptionsButton2LabelText }}
                      </button>
                    </div>
                  </div>
                </div>
                <theme7-available-components-for-sidebar
                  key="property-detail-sidebar"
                  key-prefix="property-detail-sidebar"
                  :specific-components="sidebarComponents"
                />
              </div>
            </div>
          </div>
        </div>

        <full-screen-gallery
          v-if="fullScreenPopupConfig.is_active && activeMedia && property && property.medias"
          v-model:active-media-index="activeMediaIndex"
          :component="component"
          :active-media="activeMedia"
          :count-of-medias="property.medias.length"
          @close="(closeLightbox(), toggleHeader())"
        />

        <popup :config="sendLeadPopupConfig" custom-width="800px">
          <template #content>
            <send-lead
              v-if="sendLeadPopupConfig.isActive"
              :property="property"
              @on-success="onSuccess"
              @close="sendLeadPopupConfig.isActive = false"
            />
          </template>
        </popup>

        <popup :config="videoPopupConfig" v-if="videoPopupConfig.videoPopupSrc" custom-width="500px" @close="stopVideo">
          <template #content>
            <div class="tw-relative tw-pt-6">
              <div class="tw-aspect-[9/16] tw-h-full tw-w-full">
                <library-iframe
                  class="tw-absolute tw-inset-0 tw-h-full tw-w-full"
                  :src="videoPopupConfig.videoPopupSrc"
                  frameborder="0"
                  allowfullscreen
                  :blur="imageBlurFilter"
                  :pre-market-blur-text="preMarketBlurText"
                ></library-iframe>
              </div>
            </div>
          </template>
        </popup>

        <popup :config="successModalConfig" @close="onSuccessModalClosed()">
          <template #content>
            <success :text="successPopupText" />
          </template>
        </popup>
      </section>
    </template>
    <template v-else-if="property?.is_locked">
      <section class="!tw-pt-0" style="background-color: var(--c-section_primary)">
        <div class="container">
          <library-login />
        </div>
      </section>
    </template>
  </div>
</template>

<script lang="ts">
import { mapActions, mapState } from 'pinia';
import { ROUTES } from '~/constants/ui.constants';
import { usePropertiesStore } from '~/units/properties/stores';
import type { Component } from '~/types';
import { ComponentMixin } from '~/mixins/component.mixin';
import { PropertyMixin } from '~/units/properties/mixins/property.mixin';
import FloorPlan from '~/components/common/FloorPlan.vue';
import NeuronGoogleMap from '~/components/common/NeuronGoogleMap.vue';
import Epc from '~/components/common/Epc.vue';
import NcSelect from '~/components/common/inputs/NcSelect.vue';
import NcInput from '~/components/common/inputs/NcInput.vue';
import NcButton from '~/components/common/inputs/NcButton.vue';
import FullScreenGallery from '~/components/common/FullScreenGallery.vue';
import { useCoreStore } from '~/units/core/store';
import SendLead from '~/components/common/leads/SendLead.vue';
import Success from '~/components/common/popup/Success.vue';
import Popup from '~/components/common/popup/Popup.vue';
import PropertyDetailActions from '~/components/theme4/properties/PropertyDetailActions.vue';
import AvailableComponentsForSidebar from '~/components/theme4/AvailableComponentsForSidebar.vue';
import { FullScreenPopupMixin } from '~/units/core/mixins/fullScreenPopupMixin';
import { getImagesByCount } from '~/units/properties/store';
import { Pagination as SwiperPagination } from 'swiper/modules';
import { useWebsiteStore } from '~/units/website/store';
import { Theme7ComponentsGoogleReview } from '#components';

export default defineNuxtComponent({
  name: 'Theme7PropertyDetail',
  components: {
    AvailableComponentsForSidebar,
    PropertyDetailActions,
    Popup,
    Success,
    SendLead,
    FullScreenGallery,
    NcButton,
    NcInput,
    NcSelect,
    Epc,
    NeuronGoogleMap,
    FloorPlan,
  },

  mixins: [ComponentMixin, PropertyMixin, FullScreenPopupMixin],

  data() {
    return {
      activeTab: { name: 'features', title: 'FEATURES', is_visible: !!this.featuredVideo },
      activeTabV2: { name: 'features', title: 'FEATURES' },
      swiper: {},
      isScrolled: false,
      scrollThreshold: 0,
      canPaginateBack: true,
      canPaginateNext: true,
      swiperModules: [SwiperPagination],
      variants: {
        v1: 'v1',
        v2: 'v2',
        v3: 'v3',
        v4: 'v4',
      },
      videoPopupConfig: {
        isActive: false,
        videoPopupSrc: this.featuredVideo,
      },
    };
  },

  mounted() {
    this.setScrollThreshold();
    window.addEventListener('scroll', this.handleScroll);
    this.handleScroll();
  },

  computed: {
    ...mapState(useWebsiteStore, ['company']),
    propertyAccordionItems() {
      const items = [];
      // Features
      if (this.property?.features) {
        items.push({
          title: 'Features',
          content: '',
          html: false,
          slot: 'features',
        });
      }

      // Property Information
      if (this.property?.description) {
        items.push({
          title: 'Property Information',
          content: this.property.description,
          html: true,
          slot: 'property_information',
        });
      }

      if (this.property?.floor_plans?.length) {
        items.push({
          title: 'Floor Plan',
          content: '',
          html: false,
          slot: 'floor_plan',
        });
      }

      // Map
      if (this.property?.map_position) {
        items.push({
          title: 'Map',
          content: '',
          html: false,
          slot: 'map',
        });
      }

      // EPC
      if (this.property?.epcs?.length) {
        items.push({
          title: 'EPC',
          content: '',
          html: false,
          slot: 'epc',
        });
      }

      // Media Links
      if (this.property?.extra_medias?.length) {
        items.push({
          title: 'Media Links',
          content: '',
          html: false,
          slot: 'media_links',
        });
      }

      return items;
    },

    propertyAccordionItemsV2() {
      const items = [];

      if (this.property?.floor_plans?.length) {
        items.push({
          title: 'Floor Plan',
          content: '',
          html: false,
          slot: 'floor_plan',
        });
      }

      // Features
      if (this.property?.features) {
        items.push({
          title: 'Features',
          content: '',
          html: false,
          slot: 'features',
        });
      }

      // Property Information
      items.push({
        title: 'Property Information',
        content: this.property?.description || '',
        html: true,
        slot: 'property_information',
      });

      // Map
      if (this.property?.map_position) {
        items.push({
          title: 'Map',
          content: '',
          html: false,
          slot: 'map',
        });
      }

      // EPC
      if (this.property?.epcs?.length) {
        items.push({
          title: 'EPC',
          content: '',
          html: false,
          slot: 'epc',
        });
      }

      return items;
    },

    tabs() {
      const tabs = [
        {
          name: 'features',
          title: 'FEATURES',
          is_visible: !!this.property?.features,
        },
        {
          name: 'property_information',
          title: 'PROPERTY INFO',
          is_visible: true,
        },
        {
          name: 'floor_plan',
          title: 'FLOOR PLANS',
          is_visible: !!this.property?.floor_plans?.length,
        },
        {
          name: 'map',
          title: 'MAP',
          is_visible: !!this.property.map_position,
        },
        {
          name: 'epc',
          title: 'EPC',
          is_visible: !!this.property?.epcs?.length,
        },
        // {
        //   name: 'matterport_video',
        //   title: 'VIRTUAL TOUR',
        //   is_visible: !!this.matterPort,
        // },
        // {
        //   name: 'video_tour',
        //   title: 'VIDEO TOUR',
        //   is_visible: !!this.featuredVideo,
        // },
      ];

      return tabs.filter((i) => i.is_visible);
    },

    tabsV2() {
      const tabs = [
        {
          name: 'cinematic_videography',
          title: 'CINEMATIC VIDEO',
          is_visible: !!this.featuredVideo,
        },
        {
          name: 'features',
          title: 'FEATURES',
          is_visible: !!this.property?.features,
        },
        {
          name: 'property_information',
          title: 'PROPERTY INFO',
          is_visible: true,
        },
        {
          name: 'floor_plan',
          title: 'FLOOR PLANS',
          is_visible: !!this.property?.floor_plans?.length,
        },
        {
          name: 'map',
          title: 'MAP',
          is_visible: !!this.property.map_position,
        },
        {
          name: 'epc',
          title: 'EPC',
          is_visible: !!this.property?.epcs?.length,
        },
        /*         {
          name: 'matterport_video',
          title: 'MATTERPORT VIDEO',
          is_visible: !!this.matterPort,
        }, */
      ];

      return tabs.filter((i) => i.is_visible);
    },

    markerColor() {
      return this.colors.primary;
    },

    ROUTES() {
      return ROUTES;
    },

    primaryFivePhotos() {
      if (this.property) {
        return getImagesByCount(this.property, 5);
      }
      return [];
    },

    allPhotos() {
      if (this.property) {
        return getImagesByCount(this.property, Math.min(this.property.medias.length, 10));
      }
      return [];
    },

    maxPhotosToShow() {
      if (this.property) {
        const allMedias = getImagesByCount(this.property, this.property.medias.length);
        return Array.isArray(allMedias) ? allMedias.filter((m) => m && m.isImage) : [];
      }
      return [];
    },

    primarySevenPhotos() {
      if (this.property) {
        return getImagesByCount(this.property, 7);
      }
      return [];
    },

    sidebarComponents(): Component[] {
      if (this.currentPage && this.currentPage.sidebar) {
        return this.currentPage.sidebar;
      }
      return [];
    },

    isMortgageCalculatorVisible() {
      return this.vars.isMortgageCalculatorHiddenBool;
    },

    isStampDutyCalculatorVisible() {
      return this.vars.isStampDutyCalculatorHiddenBool;
    },

    isLetterPropertyCriteria() {
      return this.vars.isLetterPropertyCriteriaBool;
    },

    featuredVideo() {
      const mediaLink = this.property?.featured_video?.mediaLink;
      if (mediaLink && mediaLink.includes('matterport')) {
        return null;
      }
      if (mediaLink === this.property?.virtual_tour?.mediaLink) {
        return null;
      }
      return mediaLink;
    },

    matterPort() {
      let mediaLink = this.property?.virtual_tour?.mediaLink;
      if (mediaLink && mediaLink.includes('youtu')) {
        return null;
      }
      if (mediaLink && mediaLink.startsWith('http://')) {
        mediaLink = mediaLink.replace('http://', 'https://');
      }
      return mediaLink;
    },
  },

  methods: {
    ...mapActions(useCoreStore, ['shareApi', 'openTab']),
    onAccordionToggle(payload: { index: number; item: any; isOpen: boolean; activeItems: number[] }) {
      try {
        if (!payload?.isOpen) return;
        const slotName = payload?.item?.slot;
        if (slotName === 'map' || slotName === 'floor_plan') {
          setTimeout(() => {
            if (typeof window !== 'undefined') {
              window.dispatchEvent(new Event('resize'));
            }
          }, 50);
        }
      } catch (error) {
        console.error('Error in onAccordionToggle:', error);
      }
    },
    async onShared() {
      await this.shareApi({
        title: this.property?.advert_heading,
        text: this.property?.advert_heading,
        url: window.location.href,
      });
    },

    onSwiper(swiper: object) {
      this.swiper = swiper;
    },

    href(location) {
      this.activeTab.name = location;
    },

    handleScroll() {
      this.isScrolled = window.scrollY > this.scrollThreshold;
    },

    setScrollThreshold() {
      nextTick(() => {
        const ulElement = this.$refs.navTabs;
        if (ulElement) {
          this.scrollThreshold = ulElement.offsetTop - 90;
        }
      });
    },

    toggleHeader() {
      if (this.property?.is_locked) {
        return;
      }
      document.body.classList.toggle('popup-open');
    },

    onVidePopup() {
      this.videoPopupConfig.isActive = !this.videoPopupConfig.isActive;
      this.videoPopupConfig.videoPopupSrc = this.featuredVideo;
    },

    stopVideo() {
      this.videoPopupConfig.videoPopupSrc = '';
    },

    methods: {
      onSwiper(swiper: any) {
        try {
          if (swiper) {
            this.swiper = swiper;
          }
        } catch (error) {
          console.error('Error in onSwiper:', error);
        }
      },

      onSlideChange() {
        try {
          if (!this.swiper) return;

          const isAtStart = this.swiper.isBeginning;
          const isAtEnd = this.swiper.isEnd;

          this.canPaginateBack = !isAtStart;
          this.canPaginateNext = !isAtEnd;
        } catch (error) {
          console.error('Error in onSlideChange:', error);
        }
      },

      slidePrev() {
        try {
          if (this.swiper) {
            this.swiper.slidePrev();
          }
        } catch (error) {
          console.error('Error in slidePrev:', error);
        }
      },

      toggleHeader() {
        try {
          document.body.classList.toggle('popup-open');
        } catch (error) {
          console.error('Error in toggleHeader:', error);
        }
      },

      slideNext() {
        try {
          if (this.swiper) {
            this.swiper.slideNext();
          }
        } catch (error) {
          console.error('Error in slideNext:', error);
        }
      },
    },
  },

  async setup(props: { component: Component }) {
    const store = usePropertiesStore();
    await store.fetchSingleProperty(props.component);
  },

  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll);
  },
});
</script>

<style scoped>
.share-button {
  border: 2px solid var(--camel);
}

.nav-link {
  color: var(--black);
  font-size: 16px;
}

.nc-first-image-overlay-item {
  position: absolute;
  bottom: 0.1rem;
  right: 0.1rem;
  transform: translate(-50%, -50%);
  text-align: right;
  background-color: var(--white);
  color: var(--c-primary) !important;
  border-radius: 4px;
  cursor: pointer !important;
}

.mortgage ::v-deep h3,
.stamp ::v-deep h3 {
  text-transform: uppercase !important;
}

.mortgage.rent-property ::v-deep .mortgage-result,
.stamp.rent-property ::v-deep .stamp-duty-result div {
  background: var(--c-tertiary) !important;
}

.mortgage.sales-property ::v-deep .mortgage-result,
.stamp.sales-property ::v-deep .stamp-duty-result div {
  background: var(--c-secondary) !important;
}

.stamp.rent-property ::v-deep .stamp-duty-button button {
  background: var(--c-tertiary) !important;
}
.stamp.sales-property ::v-deep .stamp-duty-button button {
  background: var(--c-secondary) !important;
}

.nc-all-photos-button {
  position: absolute;
  bottom: 20px;
  left: 70px;
  padding: 10px;
  border-radius: 4px;
  background-color: var(--white);
  color: var(--nc-classic-black);
}

.photo-next,
.photo-prev {
  position: absolute;
  top: 50%;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  width: 44px;
  height: 64px;
  background-color: #fff;
  border-radius: var(--rounded);
  -webkit-transform: translate(0, -50%);
  transform: translate(0, -50%);
  cursor: pointer;
  font-size: 26px;
}

.photo-next {
  right: 5%;
}

.photo-prev {
  left: 5%;
}

::v-deep(.floor-tab .floor-plan-items .floor-plan-card) {
  width: 100% !important;
}

::v-deep(.floor-tab .floor-plan-items .floor-plan-card figure) {
  border: none !important;
}

::v-deep(.floor-tab) {
  padding: unset !important;
}

::v-deep(.inline-iframe-container iframe) {
  height: 590px;
}

.theme4-floor-plan ::v-deep(figure) {
  height: unset !important;
}

.swiper-button-next::after,
.swiper-button-prev::after {
  content: unset;
}
.swiper-button-next,
.swiper-button-prev {
  width: unset;
  height: unset;
}

::v-deep(img) {
  border-radius: 4px;
}

.property-detail-card {
  padding: 24px;
  border-radius: var(--rounded);
  background-color: var(--c-section_primary);
}

.property-detail-card.accordion {
  padding-bottom: 0;
  padding-top: 0;
}

@media screen and (min-width: 1024px) {
  .property-detail-card {
    padding: 32px;
  }

  .property-detail-card.accordion {
    padding-bottom: 0;
    padding-top: 0;
  }
}

.accordion-stamp-duty-calculator ::v-deep(h3),
.accordion-mortgage-calculator ::v-deep(h3) {
  display: none;
}

.accordion-stamp-duty-calculator ::v-deep(.stamp-duty-result),
.accordion-mortgage-calculator ::v-deep(.mortgage-result) {
  background: var(--c-primary);
  border-radius: var(--rounded);
}
.accordion-stamp-duty-calculator ::v-deep(select),
.accordion-stamp-duty-calculator ::v-deep(.n-input),
.accordion-stamp-duty-calculator ::v-deep(input),
.accordion-mortgage-calculator ::v-deep(select),
.accordion-mortgage-calculator ::v-deep(.n-input),
.accordion-mortgage-calculator ::v-deep(input) {
  background: var(--c-input_secondary) !important;
}

.nav-link:hover {
  color: var(--c-primary);
}

.active {
  color: var(--c-primary) !important;
}

.ratio::before {
  display: none;
}

#epc ::v-deep(.pdf-item) {
  background-color: var(--c-section_primary);
}
</style>
